//
// Angular
//
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { map, switchMap, catchError } from 'rxjs/operators';
import { Observable, throwError, forkJoin, of, from } from 'rxjs';

//
// App
//
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';
import { SharedDataService } from '../../../core/services/shared-data.service';
import {SharedFunctionService} from '../../../core/services/shared-func.service';
//
// Libraries
//
import { isNil, cloneDeep, keysIn } from 'lodash-es';
import * as _lodash from 'lodash-es';
//
//Models
//
import * as models from '../../../shared/model/api/models';
import { DealDetails } from '../../../shared/model/api/DealDetails';

import * as moment from 'moment';
import { ViewConstants, DebugScreen, DebugAction } from '../../../constants';
import * as Lodash from 'lodash';
import { AutorizationService } from 'src/app/core/services/authorization-service';

@Injectable({
    providedIn: 'root'
})
export class WriteupsDetailService {
    private _path = '';
    private readonly dealTypeRetail = ViewConstants.DEAL_TYPE_RETAIL;
    private readonly dealTypeLease = ViewConstants.DEAL_TYPE_LEASE;
    private readonly dealTypeCash = ViewConstants.DEAL_TYPE_CASH;
    private readonly ratetermTypeRetail = ViewConstants.RATE_TERM_RETAIL;
    private readonly ratetermTypeLease = ViewConstants.RATE_TERM_LEASE;
    seriesResponseData: any;
    seriesList: any[];
    seriesData: any;
    seriesConfiguration = null;
    newSeriesData: any[];
    seriesModelCodes: { [series: string]: string[]; };
    seriesConfigurationdata: Object;
    tcuvSeriesConfigurationdata: any;
    tcuvSeriesData: any;
    inventoryResponseData: any[];
    new_inventoryResponseData: any[];
    inventoryFilter: any;
    selectedSeriesList: any;
    initialService: any;
    bothResponseData: { seriesResponseData: any; inventoryResponseData: any[]; };
    data: Promise<any>;
    seriesArray: any[];
    searchCustomerResponse: any;
    retrieveCustomerDetailsResponseData: any;
    dealTransactionId: any;
;
    private readonly ratetermTypeCash = ViewConstants.RATE_TERM_CASH;
    private get dealerCode() {
        return this.sharedService.dealerCode;
    };

    private get brand() {
        return `?brand=${this.sharedService.relationshipTypeCode}`;
    };

    constructor(private readonly httpClient: HttpClient,
        private readonly environment: EnvironmentConfiguration,
        private readonly sharedService: SharedDataService , private readonly sharedFuncService: SharedFunctionService,private readonly autorizationService: AutorizationService) {

    }

  //
    /**
     * update the message read status on opening the Chat-tab
     */
    public updateMessageReadStatus(payload): Observable<any> {
        const temp: any = {};
        temp.state = 'VISIT';
        temp.userRole = 'SALES_MANAGER';
        temp.connectionId = this.sharedService.webSocketConnectionID;
        temp.givenBy = this.sharedService.getDealerPersonnelFullNameFromToken();
        temp.dealTermId=payload.dealTermId?payload.dealTermId:"";
        let requestInstance: any = {};

        if (!isNil(payload.dealTransactionId) && !isNil(this.dealerCode)) {
            const path =
                `${this.environment.MST_BASE_SERVICE_URL  }deals/dealers/${this.dealerCode}/comments/${payload.dealTransactionId}`;
            requestInstance = this.httpClient.request('put', path, { body: this.stampScreen(temp, DebugScreen.WriteupDetail, DebugAction.OpenChat) }).pipe(
                map(response => response),
                catchError(err => this.handleErrorDetail(err))
            )
        }
        return requestInstance;
    }


    //
    /**
     * update the visited by status on opening the write-up
     */
    public updateWriteupVisitStatus(dealTransactionId): Observable<any> {

        const temp: any = {};
        temp.state = 'VISIT';
        temp.connectionId = this.sharedService.webSocketConnectionID;
        temp.salesManager = {};
        temp.salesManager.actedBy = 'ST';
        temp.cobuyer = dealTransactionId.cobuyer;
        let requestInstance: any = {};

        // this.logger.log('Executing send New Offer method');
        if (!isNil(dealTransactionId.dealTransactionId) && !isNil(this.dealerCode)) {
            const path =
                `${this.environment.MST_BASE_SERVICE_URL  }deals/dealers/${this.dealerCode}/offers/${dealTransactionId.dealTransactionId}`;
            requestInstance = this.httpClient.request('put', path, { body: this.stampScreen(temp, DebugScreen.WriteupDetail, DebugAction.OpenWriteup) }).pipe(
                // map((response: Response) => {
                map(response => response),
                catchError(err => this.handleErrorDetail(err))
            )
        }
        return requestInstance;
    }


    //
    // actual http call to fetch the data
    //
    public getWriteupsDetails(dealTransactionId: string, value: string): Observable<DealDetails> {
        //
        // SDL : Why is this a post? should be a get
        //
        // const u/rl = this._path + pageNo;
        // return this.httpClient.post<CustomerDealSummary[]>(url,);
        // return this.httpClient.getLoginService(path, requestOptions)
        // .map((response: Response) => {
        //     this.logger.log('Dealer Details Service response received ' + response.json());
        //     return response.json();
        // }).catch(this.sharedDataService.handleError);

        // https://mobile-api.rti.qa.toyota.com/deals/dealers/24022/offers/9fd7dc38-fdaf-4ca4-a9f7-64fd3c899710
        if(!isNil(value) && value === 'SaveChanges'){
            this._path = `${this.environment.MST_BASE_SERVICE_URL  }retail-deals/dealers/${this.dealerCode}/savedDeals/${dealTransactionId}`;
        } else {
        this._path = `${this.environment.MST_BASE_SERVICE_URL  }retail-deals/dealers/${this.dealerCode}/offers/${dealTransactionId}`;
        }

        const header = new HttpHeaders();
        // return this.httpClient.get<any>(_path).pipe(map((response)=>{
        //     // console.log(" response==>  ", response);
        //     return response.json()
        // }));

        // return this.httpClient.get(this._path);

        return this.httpClient.get(this._path).pipe(
            map(o => this.formatWriteupData(o,value)),
            catchError(err => this.handleErrorDetail(err))
        )

        // return this.httpClient.get(this._path, { params: params }).pipe(
        //     map(o => this.formatDataforDealView(o)))

    }

    

    /*
     * This method is used to calculatePriceEstimate Array
     */
    public calculatePriceEstimateArray(dealerCode: string, dealTransactionId: string,
        dealType: string,
        aprDetails: models.Apr[]): Observable<models.AprResponse[]> {

        const requestArray: Array<models.AprResponse> = [];
        let requestInstance: any = {};

        if (aprDetails) {
            aprDetails.forEach(apr => {
                const path = `${this.environment.MST_BASE_SERVICE_URL  }payment-nexgen/dealers/${this.dealerCode}/payments`;

                //remove dealeraddons if not present in requesst.
                apr?.offers?.forEach(dt=>
                    {
                          if(!isNil(dt.lender) && !isNil(dt.lender.name) && ((dt.lender.name.indexOf('Standard-') > -1) ||(dt.lender.name.indexOf('Special-') > -1)))
                          {
                            dt.lender.name=dt.lender.name.split('-')[1];
                          }
                          
                        })
                if(!isNil(apr.dealerAddOns)&& apr.dealerAddOns.length===0){
                    delete apr.dealerAddOns;
                }else{
                    apr.dealerAddOns = [...new Set(apr.dealerAddOns)]
                }
                this.cleanUpPaymentCall(apr)
                requestInstance = this.httpClient.post(path, this.stampScreen(apr, DebugScreen.WriteupDetail, DebugAction.CalculatePayment)).pipe(
                    // map((response: Response) => {
                    map((response: any) => {
                        this.sharedService.clearSecurityDpDetails = true;
                        this.sharedService?.updateSecurityDepositOnCalculate?.next(true);
                        let aprResponse: models.AprResponse = {};
                        const successObj: any = {};
                        successObj.error = false;
                        aprResponse = response;
                        successObj.aprDetails = aprResponse;
                        successObj.isCustomAPR = apr.isCustomAPR;
                        //for prod bug MSTM-24408 the below conditions are commented to fix payment service error alertbox.
                        // if((!isNil(response[this.ratetermTypeRetail]) && !Array.isArray(response[this.ratetermTypeRetail])) || (!isNil(response[this.dealTypeRetail]) && !Array.isArray(response[this.dealTypeRetail])) || 
                        // (!isNil(response[this.ratetermTypeLease]) && !Array.isArray(response[this.ratetermTypeLease])) || (!isNil(response[this.dealTypeLease]) && !Array.isArray(response[this.dealTypeLease])) || 
                        // (!isNil(response[this.ratetermTypeCash]) && !Array.isArray(response[this.ratetermTypeCash])) || (!isNil(response[this.dealTypeCash]) && !Array.isArray(response[this.dealTypeCash]))){
                        //     this.sharedService.paymentServiceSystemError = true;
                        // }else if((!isNil(response[this.ratetermTypeRetail]) && Array.isArray(response[this.ratetermTypeRetail])) || (!isNil(response[this.dealTypeRetail]) && Array.isArray(response[this.dealTypeRetail])) || 
                        // (!isNil(response[this.ratetermTypeLease]) && Array.isArray(response[this.ratetermTypeLease])) || (!isNil(response[this.dealTypeLease]) && Array.isArray(response[this.dealTypeLease])) || 
                        // (!isNil(response[this.ratetermTypeCash]) && Array.isArray(response[this.ratetermTypeCash])) || (!isNil(response[this.dealTypeCash]) && Array.isArray(response[this.dealTypeCash]))){
                             this.sharedService.paymentServiceSystemError = false;
                        // }
                        if (response.status === 200) {
                            successObj.value = true;
                        } else {
                            successObj.value = false;
                        }
                        return successObj;
                    }),
                    catchError(err => this.handleErrorDetail(err))
                )
                requestArray.push(requestInstance);
            });
        }
        return forkJoin(
            requestArray
        );
    }

    /*
    * This method is used to get IncetiveId from MST service Array
    */
    public getIncentiveId(vehicleDetails: models.IncetiveRequest): Observable<models.IncentiveResponse> {

        this._path = `${this.environment.MST_BASE_SERVICE_URL  }payment-nexgen/dealers/${this.dealerCode}/rebates`;

        return this.httpClient.post(this._path, this.stampScreen(vehicleDetails, DebugScreen.WriteupDetail, DebugAction.GetRebates)).pipe(
            // map((response: Response) => {
            map(response => this.replaceLeaseLoyaltyToLoyalty(response)),
            catchError(err => this.handleErrorDetail(err))
        )
    }


    replaceLeaseLoyaltyToLoyalty(response: { lease?: any[] }) {
    if (!response || !Array.isArray(response.lease)) {
        return response;
    }

    response.lease.forEach(a => {
        // offerTypeName: "leaseLoyalty" -> "Loyalty"
        if (a.offerTypeName === "leaseLoyalty") {
        a.offerTypeName = "Loyalty";
        }

        // previousOwnership: "Lease Loyalty" -> "Loyalty"
        if (a.previousOwnership === "Lease Loyalty") {
        a.previousOwnership = "Loyalty";
        }

        // typeName: "lease loyalty" -> "loyalty"
        if (a.typeName === "lease loyalty") {
        a.typeName = "loyalty";
        }

        // compatibilityList contains "lease loyalty" -> replace with "loyalty"
        if (
        Array.isArray(a.compatibilityList) &&
        a.compatibilityList.includes("lease loyalty")
        ) {
        a.compatibilityList = a.compatibilityList.map(item =>
            item === "lease loyalty" ? "loyalty" : item
        );
        }
    });
    return response;
    }

    private formatWriteupData(data: any, value?:string) {
        let dealDetailData: DealDetails = null;
        if(_lodash.isEmpty(data))

        {
            data['emptyResponse']=true
            dealDetailData=data;
            return dealDetailData;
        }
      
      // console.log("Write up Data ==> ", data);
      if(value && value === 'SaveChanges') {
        this.sharedService.cloneDealData = undefined;
        const updatedDate = data['updatedDateTime'];
        const savedDealId= data['savedDealId'];
        data = data['deals'][0];
        data['draft'] = 'DRAFT';
        data['saveDealupdatedDate'] = updatedDate;
        data['savedDealId'] = savedDealId;
        this.sharedService.savedDealId = savedDealId;
        }
        this.sharedService.setDealDataResponse(cloneDeep(data));
        this.sharedService.setOriginalPriceGrid(cloneDeep(data))
       
        data['tempApproved'] = data.approvedOffer;
        data['deskDealApprovedOffer'] = data.approvedOffer;
        if (data?.vehicle?.modelYear && data.vehicle.modelMarketingName) {
            data.vehicle = (<any>Object).assign({}, data.vehicle, {
                modelName: `${data.vehicle.modelYear  } ${  data.vehicle.modelMarketingName}`
            });
        }
        if (data?.vehicle &&  isNil(data.vehicle.grade)) {
            data.vehicle = (<any>Object).assign({}, data.vehicle, {
                grade: ''
            });
        }
        if(!isNil(data.paymentType) && data.paymentType.toLowerCase().indexOf('lease')>-1){
            data['tempLeaseType'] = isNil(data.leaseType) ? 'regular' : data.leaseType;
        }
        if(!isNil(data.leaseType) && data.leaseType.toLowerCase()==='regular_lease'){
            data.leaseType='regular'
        }
        if(!isNil(data.taxesAndFees)){
            data['temptotalTaxesAndFees'] = data.taxesAndFees.totalTaxesAndFees;
        }
        if (data.estimatedOffer.offerType) {
            data.estimatedOffer = (<any>Object).assign({}, data.estimatedOffer, {
                dealtype: data.estimatedOffer.offerType
            });
        } else {
            data.estimatedOffer = (<any>Object).assign({}, data.estimatedOffer, {
                dealtype: 'Trade'
            });
        }

        // Temporary fix - When MSTC is sending null for totalMonths in estimatedOffer, making is 0
        if (!isNil(data.estimatedOffer) && _lodash.get(data, 'estimatedOffer.offerType', '').toLowerCase() === ViewConstants.DEAL_TYPE_CASH) {
            data.estimatedOffer = (<any>Object).assign({}, data.estimatedOffer, {
                totalMonths: 0
            }); 
        }
        if (!isNil(data.approvedOffer) && _lodash.get(data, 'approvedOffer.offerType', '').toLowerCase() === ViewConstants.DEAL_TYPE_CASH) {
            data.approvedOffer = (<any>Object).assign({}, data.approvedOffer, {
                totalMonths: 0
            }); 
        }

        if (data && data.status.toUpperCase() === 'DEALER APPROVED') {

            data.status = 'Dealer Approved';
        } else if (data && data.status.toUpperCase() === 'INITIATED') {
            data.status = 'Intitated';
        }
        else if (data && data.status.toUpperCase() === 'CUSTOMER_ACCEPTED') {
            data.status = 'Finalized';
        }
        else if (data && data.status.toUpperCase() === 'WRITE-UP PRICED') {
            data.status = 'Write-up Priced';
        }
        else if (data && data.status.toUpperCase() === 'PENDING_APPROVAL') {
            data.status = 'Pending Review';
        }
        else if (data && data.status.toUpperCase() === 'EXPIRED') {
            data.status = 'Expired';
        }
        else if (data && data.status.toUpperCase() === 'CANCELLED') {
            data.status = 'Cancelled';
        }
        else if (data && data.status.toUpperCase() === ViewConstants.DEAL_STATUS_CONTRACT_APPROVED.toUpperCase()) {
            data.status = 'Contract Approved';
        }

        else if (data.status.indexOf('_') > 0) {

            data.status = data.status.replace('_', ' ');
        }
        let tempDealType = '';
        let tempPaymentType = '';
        if (!isNil(data.dealType)) {
            tempDealType = data.dealType;
        }
        if (!isNil(data.paymentType)) {
            tempPaymentType = data.paymentType;
        } if ((tempDealType.toLowerCase() === 'tradein') ||
            (tempDealType.toLowerCase() === 'tradein&payment')) {
            tempDealType = 'Trade'
        } else {
            tempDealType = '';
        }
        if (tempPaymentType.toLowerCase() === 'apr') {
            tempPaymentType = 'Finance';
        } else if (tempPaymentType.toLowerCase() === 'lease') {
            tempPaymentType = 'Lease';
        } else if (tempPaymentType.toLowerCase() === 'cash') {
            tempPaymentType = 'Cash';
        }
        let offerType = '';
        if (tempDealType !== '' && tempPaymentType !== '') {
            offerType = `${tempDealType  } - ${  tempPaymentType}`;
        } else if (tempDealType !== '') {
            offerType = tempDealType;
        } else if (tempPaymentType !== '') {
            offerType = tempPaymentType;
        }
        if (!isNil(data)) {
            data.dealType = offerType;
        }
        let editedAdjustedDealerSellingPrice;
        let isCashSubmitted =false;
        if(!isNil(data.approvedOffer) && typeof data.approvedOffer.adjustedDealerSellingPrice!=='undefined')
        {
            editedAdjustedDealerSellingPrice=data.approvedOffer.adjustedDealerSellingPrice;
        }
        if( tempPaymentType?.toLowerCase() === 'Cash'.toLowerCase() && !isNil(data.approvedOffer) && typeof data.approvedOffer.cashDown!=='undefined' && isNil(data.approvedOffer.cashDown))
        {
            isCashSubmitted=true;
        }
        if(!isNil(data.approvedOffer) && isNil(data.approvedOffer.cashDown) && data.approvedOffer.offerType === "CASH") {
            data.approvedOffer.cashDown = 0;
        }
        if (isNil(data.approvedOffer) || isNil(data.approvedOffer.cashDown)) {
            data.approvedOffer = (<any>Object).assign({}, data.estimatedOffer);
            //data.approvedOffer.adjustedDealerSellingPrice = data.vehicle.dealerSellingPrice;
            if(isCashSubmitted && !isNil(editedAdjustedDealerSellingPrice))
            {
                data.approvedOffer.adjustedDealerSellingPrice=editedAdjustedDealerSellingPrice;
            }
            
        }
        if(!isNil(data.approvedOffer) && isNil(data.approvedOffer.cashDown) && data.estimatedOffer.offerType === "CASH") {
            data.approvedOffer.cashDown = 0;
        }
        // data.vehicle.daysInStock = dataFormatter.CalculateDIS(
        //     data.vehicle.dealerCategory,
        //     data.vehicle.invoiceDate,
        //     data.vehicle.vehicleTradedDate,
        //     data.vehicle.daysInStock);

        data.vehicle.dis = this.calculateDaysInStock(
            data.vehicle.daysInStock,
            data.vehicle.invoiceDate,
            data.vehicle.vehicleTradedDate,
        );

        const newTradeData = data.tradeIns.filter(dt => 
            !isNil(dt.year) && !isNil(dt.make) && !isNil(dt.model) && !isNil(dt.vin) && !isNil(dt.mileage)
        );
        data.tradeIns = newTradeData;
        if (!isNil(data.tradeIns)) {
            if(value && value === 'SaveChanges'){
                data.tradeIns.map(dt=>{
                if(dt && isNil(dt.status)){
                    dt.status = 'COMPLETED';
                }
                })
            }
            data.tradeIns.filter(dt => dt.tradeInAmount === 0).map(dt => dt.tradeInAmount = 0); // Changing null to zero
            data.tradeIns.filter(dt => dt.payOffAmount === 0).map(dt => dt.payOffAmount = 0);
            data.tradeIns.filter(dt => dt.status.toUpperCase() === 'COMPLETED').map(dt => dt.status = 'Trade Processed');
            data.tradeIns.filter(dt => dt.status.toUpperCase() === 'PENDING_APPROVAL').map(dt => dt.status = 'Trade Pending');
        }

        dealDetailData = data;
        if(!isNil(dealDetailData.priceGrid) && !isNil(dealDetailData.priceGrid.details) && dealDetailData.priceGrid.details.length>0 )
        {
            dealDetailData.priceGrid.details.forEach((item,i)=>{
                if(item.type?.toLowerCase()!=='cash' &&  item?.lender?.name?.indexOf('dummyLender')!==-1)
                {
                    dealDetailData.priceGrid.details[i].isSubvented=false;   
                }
                if(item.type?.toLowerCase()!=='cash' && isNil(item?.rate)){
                    if(item?.lender?.name?.toLowerCase()==='custom'){
                        if(item?.isSelected){
                            if(!isNil(dealDetailData?.estimatedOffer?.aprOrRCR) ){
                                item.rate=[dealDetailData?.estimatedOffer?.aprOrRCR,dealDetailData?.estimatedOffer?.aprOrRCR,dealDetailData?.estimatedOffer?.aprOrRCR];
                                item.originalRate=[dealDetailData?.estimatedOffer?.aprOrRCR,dealDetailData?.estimatedOffer?.aprOrRCR,dealDetailData?.estimatedOffer?.aprOrRCR];
                            }else{
                                delete item?.rate;
                                delete item?.originalRate;
                                item.lender = {id: `dummyLender${i}`, name: `dummyLender${i}`, displayName: `dummyLender${i}`};
                            }                                          
                        }else{
                            delete item?.rate;
                            delete item?.originalRate;
                            item.lender = {id: `dummyLender${i}`, name: `dummyLender${i}`, displayName: `dummyLender${i}`};
                        }
                    }
                else{
                    delete item?.rate;
                    delete item?.originalRate;
                    item.isStandardRate=true;
                }
            }
            })
        }
       // newTradeData = this.sharedFuncService.descOrderDate(newTradeData);
        dealDetailData.tradeIns =  this.sharedFuncService.descOrderDate(newTradeData);
        return dealDetailData;
    }

    //Method to calculate the days in stock value based on previous days in stock, invoice and vehicle traded date

    private calculateDaysInStock(previousDaysInStock,
        invoiceDate, vehicleTradedDate) {

        //Variable to store the final days in stock value

        let daysInStock =
            0;



        //Check if there is any value for days in stock in service response

        const vinDaysInStock = (!isNil(previousDaysInStock) &&
            !isNaN(parseInt(previousDaysInStock,
                0))) ? previousDaysInStock :
            0;

        //Check if there is any value for invoice date in service response and convert to utc string

        const vinInvoiceDate = !isNil(invoiceDate) ?
            moment.utc(invoiceDate).format() :
            '';

        //Check if there is any value for vehicle traded date in service response and convert to utc string

        const vinVehicleTradedDate = !isNil(vehicleTradedDate) ?
            moment.utc(vehicleTradedDate).format() :
            '';

        //Get the current date string in utc format

        const todaysDate =
            moment.utc().format();



        //If both dates are available and invoice date is later to traded date, then vehicle age is from invoice date

        if (vinInvoiceDate.length >
            0 && vinVehicleTradedDate.length >
            0 && new
                Date(vinInvoiceDate) >
            new Date(vinVehicleTradedDate)) {

            daysInStock =
                Math.floor(moment.duration(moment(todaysDate).diff(moment(vinInvoiceDate))).asDays())
                + parseInt(vinDaysInStock,
                    0);

        }

        //Otherwise if trade data is available, then vehicle age is from traded date

        else if (vinVehicleTradedDate.length >
            0) {

            daysInStock =
                Math.floor(moment.duration(moment(todaysDate).diff(moment(vinVehicleTradedDate))).asDays())
                + parseInt(vinDaysInStock,
                    0);

        }

        //Otherwise if invoice date is available, then vehicle age is from invoice date

        else if (vinInvoiceDate.length >
            0) {

            daysInStock =
                Math.floor(moment.duration(moment(todaysDate).diff(moment(vinInvoiceDate))).asDays())
                + parseInt(vinDaysInStock,
                    0);

        }
        if (!Number.isNaN(daysInStock)) {
            if(daysInStock<0)
            {
                return "N/A";
            }
            else{
                return String(daysInStock);
            }
            
        }
        else {
            return "";
        }

    }


    private totalValue = 0;
    private nameValuePair: any[] = [];
    private sourceKeys: string[] = [];
    private taxParam: any = {};
    private salesTaxList: any[] = [];
    private nonSalesTaxList: any[] = [];
    private isSalesTaxArrayFlag: boolean;
    private taxType: string;
    private taxAmount: number;

    public getPropertyValuesForMST(keyEndName: string, objectToIterate: any, getPropName?: any): any {
        this.totalValue = 0;
        this.nameValuePair = [];
        this.sourceKeys = [];
        this.taxParam = {};
        this.salesTaxList = [];
        this.nonSalesTaxList = [];
        this.taxType = '';
        this.taxAmount = 0;
        this.isSalesTaxArrayFlag = this.sharedService.setAndGetValues('salesTaxArrayFlag', false, null);
        this.calculateValuesForMST(keyEndName, objectToIterate, getPropName, null);
        return { totalValue: this.totalValue, nameValuePair: this.nameValuePair, salesTaxList: this.salesTaxList, nonSalesTaxList: this.nonSalesTaxList };
    }

    private calculateValuesForMST(keyEndName: string, objectToIterate: any, getPropName: any,
        keyToBeDisplayed: string) {
        let objectKeys = keysIn(objectToIterate);
        if(!isNil(objectKeys) && objectKeys.length >0){
            objectKeys = objectKeys.filter(obj => obj?.toLowerCase() !=='priceIncludingDealerFees'.toLowerCase() && obj !== 'dealerFee' && obj?.toLowerCase() !=='totalDealerFees'.toLowerCase())
        }
        let loopKeys: string[] = objectKeys;
        if (!isNil(keyEndName) && keyEndName !== '') {
            loopKeys = objectKeys.filter(dt => dt.indexOf(keyEndName) !== -1 &&
                dt.indexOf(keyEndName) === (dt.length - keyEndName.length));
        }
        if (this.sourceKeys.length === 0) {
            this.sourceKeys = loopKeys;
        }
        loopKeys.forEach((key, index) => {
            const propValue = objectToIterate[key];
            const propType = `${Object.prototype.toString.call(propValue)  }`;
            let i = 0;
            if(key === 'capitalizedTaxes' || key === 'nonCapitalizedTaxes'|| key === "financeItemizedTaxes" || key === "nonFinanceItemizedTaxes" ) {
                this.taxType = key;
                // this.finalTaxList.push(this.taxType);
            }
            if(key === "nonFinanceItemizedTaxes") {
                for(const property in objectToIterate.nonFinanceItemizedTaxes){ 
                    if(`${property}`.toLowerCase() !== 'salestax') {this.nonSalesTaxList.push({...objectToIterate.nonFinanceItemizedTaxes[property], name: `${property}`,taxType:'nonFinanceItemizedTaxes'})}
                }
            }
            if(key === "financeItemizedTaxes") {
                for(const property in objectToIterate.financeItemizedTaxes){ 
                    if(`${property}`.toLowerCase() !== 'salestax') {this.nonSalesTaxList.push({...objectToIterate.financeItemizedTaxes[property], name: `${property}`,taxType:'financeItemizedTaxes'})}
                }
            }
            if(key === "capitalizedTaxes") {
                for(const property in objectToIterate.capitalizedTaxes){ 
                    if(`${property}`.toLowerCase() !== 'salestax') {this.nonSalesTaxList.push({...objectToIterate.capitalizedTaxes[property], name: `${property}`,taxType:'capitalizedTaxes'})}
                }
            }
            if(key === "nonCapitalizedTaxes") {
                for(const property in objectToIterate.nonCapitalizedTaxes){ 
                    if(`${property}`.toLowerCase() !== 'salestax') {this.nonSalesTaxList.push({...objectToIterate.nonCapitalizedTaxes[property], name: `${property}`,taxType:'nonCapitalizedTaxes'})}
                }
            }
            if (propType.indexOf('Array') !== -1) {
                const tempArray: Array<any> = propValue;
                if (tempArray.length > 0) {
                    tempArray.forEach(arrayItem => {
                        i = i + (tempArray.length);
                        if (i <= tempArray.length) {
                            this.calculateValuesForMST(null, propValue, getPropName, key);
                        }
                    });
                }
            } else if (propType.indexOf('Object') !== -1) {
                if (key !== 'taxParameters') {
                    if (this.sourceKeys.indexOf(key) === -1)
                        {this.calculateValuesForMST(null, propValue, getPropName, key);}
                    else
                        {this.calculateValuesForMST(null, propValue, getPropName, null);}
                }
                else if(key === 'taxParameters') {
                    this.taxParam = propValue
                    // console.log("Rate ==> ", this.taxParam);
                }
            } else if (propType.indexOf('String') !== -1 && this.isSalesTaxArrayFlag) {
                if(key === 'name') {
                    this.salesTaxList.push({
                        name: objectToIterate.name, 
                        rate: objectToIterate.taxParameters, 
                        taxType: this.taxType,
                        id: objectToIterate.id,
                        value: objectToIterate.salesTaxAmount
                    });
                    // console.log("Name ==> ", this.salesTaxList);
                }
                // if(key === 'id') {
                //     if(this.salesTaxList && this.salesTaxList.length > 0) {
                //         this.salesTaxList.map(dt => {
                //             this.salesTaxList[this.salesTaxList.length - 1].id = propValue;
                //             this.salesTaxList[this.salesTaxList.length - 1].value = this.taxAmount;
                //         })
                //     }
                //     // console.log("Name ==> ", this.salesTaxList);
                // }
            } else if (!isNil(propValue) && !isNaN(propValue)) {
                // if(propType.indexOf('String') === -1)  || propType.indexOf('String') !== -1
                if(key !== 'id') {
                    this.totalValue = this.totalValue + parseFloat(propValue);
                }
                if (!isNil(getPropName) &&
                    (`${Object.prototype.toString.call(getPropName)  }`).indexOf('Function') !== -1) {
                    const tempKey = !isNil(keyToBeDisplayed) ? getPropName(keyToBeDisplayed) :
                        getPropName(key);
                    let nameValue: any = {};
                    const tempNameValuePair = this.nameValuePair.filter(nvp => nvp.name === tempKey);
                    if (this.removeTotalItems(tempKey)) // For Removing the Total details getting from response
                        {if (!isNil(tempNameValuePair) && tempNameValuePair.length > 0) {
                            nameValue = tempNameValuePair[0];
                            if(key !== 'id') {
                                this.taxAmount = propValue;
                                if (isNil(nameValue.value)) {

                                    nameValue.value = propValue;
                                }
                                else {
                                        nameValue.value += parseFloat(propValue);
                                        nameValue.value.toString();  
                                }
                            } else {
                                nameValue.id = propValue;
                            } 
                            
                            //nameValue.value = propValue;
                        } else {
                            nameValue.name = tempKey;
                            if(key !== 'id') {
                                this.taxAmount = propValue;
                                if (isNil(nameValue.value)) {
                                    nameValue.value = parseFloat(propValue);
                                    nameValue.value.toString();
                                }
                                else {
                                    nameValue.value += parseFloat(propValue);
                                }
                            } else {
                                nameValue.id = propValue;
                            }                           
                            //nameValue.value = propValue;
                                this.nameValuePair.push(nameValue);
                        }}
                }
            }
        });
    }

    public removeTotalItems(key: string) {
        // tempKey !== 'totalCapitalizedFees' && tempKey !== 'totalCapitalizedTaxes' && tempKey !== 'totalNonCapitalizedFees'
        //                 || tempKey !== 'totalNonCapitalizedTaxes' && tempKey !== 'totalFees' && tempKey !== 'totalTaxes'
        switch (key) {
            case 'totalCapitalizedFees':
                return false;

            case 'totalCapitalizedTaxes':
                return false;

            case 'totalNonCapitalizedFees':
                return false;

            case 'totalNonCapitalizedTaxes':
                return false;
            case 'totalFees':
                return false;
            case 'totalTaxes':
                return false;
            default:
                return true;
        }
    }

    /***
     * This method is used obtain DealDetailsImageValues
     */
    public getDealDetailsImageValues(tradeInImages: Array<models.TradeInImageData>,
        dealerCode: string, customerId: string): Observable<any> {
        const requestArray: Array<any> = [];
        let requestInstance: any = {};
        tradeInImages.forEach(imagedata => {
            imagedata.imgName.forEach(imageName => {
                const path = `${this.environment.MST_BASE_SERVICE_URL  }deals/dealers/${  dealerCode  }/offers/dealTerms/${  customerId
                     }/${  imagedata.vinId  }/image/${  imageName}`;
                const queryParameters = new URLSearchParams();
                requestInstance = this.httpClient.get(path).pipe(
                    map((response: Response) => {
                        const successObj: any = {};
                        successObj.error = false;
                        successObj.ImgName = imageName;
                        successObj.vin = imagedata.vinId;
                        successObj.value = response;
                        return successObj;
                    }),
                    catchError(err => this.handleErrorDetail(err)));
                requestArray.push(requestInstance);
            });
        });
        return forkJoin(
            requestArray
        );
    }

    /**
    * get data to delete trade
    */
    public getDeleteTrade(data): Observable<any> {

        const path = `${this.environment.MST_BASE_SERVICE_URL  }deals/dealers/${  data.dealerCode  }/trade`;
        const requestArray: Array<models.DeleteTradeIn> = [];
        let requestInstance: any = {};

        if (data) {
            const payload = {
                "customerId": data.customerId,
                "vinId": data.vinId,
                "dealTermId": data.dealTermId,
                "isDealInitiated": data.isDealInitiated
            };

            requestInstance = this.httpClient.request('delete', path, { body: payload }).pipe(
                // map((response: Response) => {
                map(response => response),
                catchError(err => this.handleErrorDetail(err))
            )
        }
        return requestInstance;

    }

    getAllMessages(requestValue): Observable<any>{
       // https://mobile-api.rti.qa.toyota.com/deals/dealers/24022/offers/8bd093e5-8699-4918-bc8a-6704bd4bcc23?comments=true

       let requestInstance: any = {};
           const path = `${this.environment.MST_BASE_SERVICE_URL  }retail-deals/dealers/${  requestValue.customer.dealerCode  }/offers/${  requestValue.dealTransactionId}?comments=true`;
           requestInstance = this.httpClient.request('get', path).pipe(
                map(response => (response)),
                catchError(err => this.handleErrorDetail(err))
           )
       return requestInstance;
    }
    formateDate(messages){
        messages.map(x => {
            x.commentDate = this.sharedFuncService.formatMessagesTime(x.commentDate);
            if (typeof x.tmIconName === 'undefined' || (x.tmIconName != "checkmark-circle" && x.tmIconName != "campaign-on")) {
                x.tmIconName = "reserved-yes";
              }
          })
          return messages;
    }
    /*
        * This method is used to send New Message 
        */
    public sendNewMessage(requestValue): Observable<any> {
        const requestInstance: any = {};
        if (!isNil(requestValue)) {
            const getRequestValue = {
                dealerCode: requestValue.dealerCode,
                dealTransactionId: requestValue.dealTransactionId,
                commentPayload: requestValue.commentPayload
            };

            if (!isNil(getRequestValue) && !isNil(getRequestValue.commentPayload)) {

                const path = `${this.environment.MST_BASE_SERVICE_URL  }deals/dealers/${  getRequestValue.dealerCode  }/comments/${  getRequestValue.dealTransactionId}`;

                return this.httpClient.request('put', path, { body: getRequestValue.commentPayload }).pipe(
                    // map((response: Response) => {
                    map(response => response),
                     catchError(err => this.handleErrorDetail(err))
                )


            }
        }
        //return requestInstance;
    }

  /**
    * send desk deal Service
    */
   public sendDeskDeal(requestValue): Observable<any> {
    if(!isNil(requestValue) && !isNil(requestValue.dealDetails) && !isNil(requestValue.dealDetails.priceGrid) && !isNil(requestValue.dealDetails.priceGrid.details))
    {
requestValue.dealDetails.priceGrid.details.map(dt=>
      {
        if(!isNil(dt.lender) && !isNil(dt.lender.name) && ((dt.lender.name.indexOf('Standard-') > -1) ||(dt.lender.name.indexOf('Special-') > -1)))
            {
              dt.lender.name=dt.lender.name.split('-')[1];
            }
      })
    }
    const getRequestValue = {
        dealerCode: requestValue.dealerCode,
        dealTransactionId: requestValue.dealTransactionId,
        dealDetails: requestValue.dealDetails
    };
    if(requestValue.isApprovedEmpty)
    {
        if(getRequestValue.dealDetails.approvedOffer)
        {
            getRequestValue.dealDetails.approvedOffer={}
        }
    }

    if (!isNil(getRequestValue) && !isNil(getRequestValue.dealDetails)) {

        const path = `${this.environment.MST_BASE_SERVICE_URL  }deals/dealers/${  getRequestValue.dealerCode  }/sendDesking/${  getRequestValue.dealTransactionId}`;

        return this.httpClient.request('post',path, { body: getRequestValue.dealDetails }).pipe(
            // map((response: Response) => {
            map(response => response)
            , catchError(err => this.handleErrorDetail(err))
        )
        
    }
    //return requestInstance;
}
public sendDealJacket(requestValue): Observable<any> {
    if(!isNil(requestValue) && !isNil(requestValue.dealDetails) && !isNil(requestValue.dealDetails.priceGrid) && !isNil(requestValue.dealDetails.priceGrid.details))
    {
requestValue.dealDetails.priceGrid.details.map(dt=>
      {
        if(!isNil(dt.lender) && !isNil(dt.lender.name) && ((dt.lender.name.indexOf('Standard-') > -1) ||(dt.lender.name.indexOf('Special-') > -1)))
            {
              dt.lender.name=dt.lender.name.split('-')[1];
            }
      })
    }
    const getRequestValue = {
        dealerCode: requestValue.dealerCode,
        dealTransactionId: requestValue.dealTransactionId,
        dealDetails: requestValue.dealDetails
    };


    if (!isNil(getRequestValue) && !isNil(getRequestValue.dealDetails)) {

        const path = `${this.environment.MST_BASE_SERVICE_URL  }digitalfi/shareDealJacket/dealers/${  getRequestValue.dealerCode }/${  getRequestValue.dealTransactionId}`;

        return this.httpClient.request('post',path, { body: getRequestValue.dealDetails }).pipe(
            // map((response: Response) => {
            map(response => response)
            , catchError(err => this.handleErrorDetail(err))
        )
        
    }
    //return requestInstance;
}
    /**
    * get data to delete trade
    */
    public sendNewOffer(requestValue): Observable<any> {
        if(!isNil(requestValue?.dealDetails?.priceGrid?.details)){
            requestValue.dealDetails.priceGrid.details.map(dt=>{
            if((dt?.lender?.name?.indexOf('Standard-') > -1) ||(dt?.lender?.name?.indexOf('Special-') > -1)){
              dt.lender.name=dt.lender.name.split('-')[1];
            }
          })
        }
        if(requestValue.dealDetails.dealType === 'Trade' || requestValue.dealDetails.dealType === 'trade') {
            requestValue.dealDetails.upfrontFlags = {};
        }
        const getRequestValue = {
            dealerCode: requestValue.dealerCode,
            dealTransactionId: requestValue.dealTransactionId,
            dealDetails: requestValue.dealDetails
        };
        const requestInstance: any = {};

        // this.logger.log('Executing send New Offer method');
        if (!isNil(getRequestValue) && !isNil(getRequestValue.dealDetails)) {

            const path = `${this.environment.MST_BASE_SERVICE_URL  }deals/dealers/${  getRequestValue.dealerCode  }/offers/${  getRequestValue.dealTransactionId}`;

            return this.httpClient.request('put',path, { body: this.stampScreen(getRequestValue.dealDetails, DebugScreen.WriteupDetail, DebugAction.SendOffer) }).pipe(
                // map((response: Response) => {
                map(response => response)
                , catchError(err => this.handleErrorDetail(err))
            )
            
        }
        //return requestInstance;
    }
    //Save Changes
    public saveChanges(requestValue): Observable<any> {
        if(!isNil(requestValue) && !isNil(requestValue.dealDetails) && !isNil(requestValue.dealDetails.priceGrid) && !isNil(requestValue.dealDetails.priceGrid.details))
        {
 requestValue.dealDetails.priceGrid.details.map(dt=>
          {
            if(!isNil(dt.lender) && !isNil(dt.lender.name) && ((dt.lender.name.indexOf('Standard-') > -1) ||(dt.lender.name.indexOf('Special-') > -1)))
            {
              dt.lender.name=dt.lender.name.split('-')[1];
            }
          })
        }
        const request = {
            deals : [requestValue.dealDetails],
            savedDealId: requestValue.dealDetails['savedDealId'] ? requestValue.dealDetails['savedDealId'] : undefined,
            updatedDateTime: requestValue.dealDetails['saveDealupdatedDate'] ? requestValue.dealDetails['saveDealupdatedDate'] : undefined
        };
        // this.logger.log('Executing save changes method');
        if (!isNil(requestValue) && !isNil(requestValue.dealDetails)) {
            const path = `${this.environment.MST_BASE_SERVICE_URL  }deals/dealers/${  requestValue.dealerCode  }/savedDeals/${  requestValue.dealTransactionId}`;
            return this.httpClient.request('put',path, { body:  request }).pipe(
                // map((response: Response) => {
                map(response => response)
                , catchError(err => this.handleErrorDetail(err))
            )
            
        }
    }
    //Clone Deal
    public cloneDeal(requestValue): Observable<any> {
        // this.logger.log('Executing clone method');
        if (!isNil(requestValue?.dealDetails)) {
            if(!isNil(requestValue?.dealDetails?.priceGrid?.details)){
            requestValue.dealDetails.priceGrid.details.map(dt=>{
                if(!isNil(dt.lender) && !isNil(dt.lender.name)  && ((dt.lender.name.indexOf('Standard-') > -1) ||(dt.lender.name.indexOf('Special-') > -1)))
                {
                  dt.lender.name=dt.lender.name.split('-')[1];
                }
              })
            }
            const path = `${this.environment.MST_BASE_SERVICE_URL  }deals/dealers/${  requestValue.dealerCode  }/offers`;
            return this.httpClient.post(path, this.stampScreen(requestValue.dealDetails, DebugScreen.WriteupDetail, DebugAction.CloneDeal)).pipe(
                map(response => { 
                    if(response){
                        this.sharedService.cloneResponse = response;
                        this.sharedService.grossProfitData.next(null);
                        // this.sharedService.grossProfitDataForSelectionChange.next(null);
                    }
                }),
                catchError(err => this.handleErrorDetail(err))
            )
            
        }
    }
    private stampScreen<T>(body: T, screenName: string, userAction?: string): T {
        if (body && typeof body === 'object') {
            const debug: any = { ...(((body as any).debugInfo) || {}), screenName };
            if (userAction !== undefined) { debug.userAction = userAction; }
            (body as any).debugInfo = debug;
        }
        return body;
    }

    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        return throwError(errorMessage);
    
    }
    handleErrorDetail(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // server-side error            
            if (error.error instanceof Object) {errorMessage = !isNil(error?.error?.errorDesc) ? error.error.errorDesc:"Service Error";}
            else {errorMessage = error.error;}
        }
        return throwError(errorMessage);
    }
    /**
   * get the Vin for Finalized Write-ups
   */
    public getTradeVinids(data): Observable<any> {

        const path = `${this.environment.MST_BASE_SERVICE_URL  }retail-deals/trade/deals`;
        const queryParameters = new URLSearchParams();

        if (data) {

            return this.httpClient.post(path, this.stampScreen(data, DebugScreen.WriteupDetail, DebugAction.GetTradeVins)).pipe(
                // map((response: Response) => {
                map(response => response), catchError(err => this.handleErrorDetail(err))
            )
        }
    }

    /**
     *  Get the protection products
     */
    public getProtectionProducts(data): Observable<any> {

        // this._path = this.environment.MST_BASE_SERVICE_URL + `digitalfi/dealers/${this.dealerCode}/worksheet` + this.brand;

        this._path =  `${this.environment.MST_BASE_SERVICE_URL  }digitalfi/products/${  this.dealerCode  }/${  data.vin  }?modelYear=${  data.modelYear  }&type=` + `New` + `&mileage=12000&brand=${  data.brand}`;

        return this.httpClient.get(this._path).pipe(
            // map((response: Response) => {
            map(response => response), catchError(err => this.handleErrorDetail(err))
        )
    }

    /**
     *  Get the protection products
     */
    public viewProtectionProducts(data): Observable<any> {

        // this._path = this.environment.MST_BASE_SERVICE_URL + `digitalfi/dealers/${this.dealerCode}/worksheet/view` + this.brand;

        const mileage =  data.mileage ? `&mileage=${data.mileage}` : '';
        //this._path = this.environment.MST_BASE_SERVICE_URL + 'digitalfi/products/dealers/' + this.dealerCode + '/' + data.vin + '?modelYear=' + data.modelYear  + '&type=' + data.vehicleType   + '&model=' + data.model + dofu + mileage + '&brand=' + data.brand;
        this._path = `${this.environment.MST_BASE_SERVICE_URL  }payment-nexgen/dealers/${  this.dealerCode  }/protectionproducts`;
        const request: any = { 
            vehicle: {
                model: data.model,
                make: data.brand,
                vin: data.vin,
                modelYear: data.modelYear,
                salesClass: data.vehicleType,
                mileage: ''
            },
            senderId: "CON",
            regionCode: '',
            terms: {
                finance: data.aprTerms,
                lease: data.leaseTerms
            }
        }

        if(data.dofu && data.dofu !== '') {
            request.dofu = data.dofu;
        }

        if(data.mileage && data.mileage !== '') {
            request.vehicle.mileage = data.mileage;
        }

        if(this.sharedService && this.sharedService.divisionCodeValue) {
            request.regionCode = this.sharedService.divisionCodeValue;
        }
        
        if(!isNil(data.vehicle) && !isNil(data.vehicle.invoiceAmount)){
            delete data.vehicle.invoiceAmount;
        }
        return this.httpClient.post(this._path, this.stampScreen(request, DebugScreen.WriteupDetail, DebugAction.LoadProtectionProducts)).pipe(
            // map((response: Response) => {
            map(response => response), catchError(err => this.handleErrorDetail(err))
        )
    }

    /**
     *  Get the protection products
     */
    public updateProtectionProducts(requestValue): Observable<any> {

        if(!isNil(requestValue) && !isNil(requestValue.dealDetails) && !isNil(requestValue.dealDetails.priceGrid) && !isNil(requestValue.dealDetails.priceGrid.details))
        {
 requestValue.dealDetails.priceGrid.details.map(dt=>
          {
            if(!isNil(dt.lender) && !isNil(dt.lender.name) && ((dt.lender.name.indexOf('Standard-') > -1) ||(dt.lender.name.indexOf('Special-') > -1)))
            {
              dt.lender.name=dt.lender.name.split('-')[1];
            }
          })
        }
        const getRequestValue = {
            dealerCode: requestValue.dealerCode,
            dealTransactionId: requestValue.dealTransactionId,
            dealDetails: requestValue.dealDetails
        };
        const requestInstance: any = {};

        // this.logger.log('Executing send New Offer method');
        if (!isNil(getRequestValue) && !isNil(getRequestValue.dealDetails)) {

            const path = `${this.environment.MST_BASE_SERVICE_URL  }deals/dealers/${  getRequestValue.dealerCode  }/offers/${  getRequestValue.dealTransactionId}`;
          

            return this.httpClient.request('put',path, { body: this.stampScreen(getRequestValue.dealDetails, DebugScreen.WriteupDetail, DebugAction.UpdateProtectionProducts) }).pipe(
                // map((response: Response) => {
                map(response => response)
                , catchError(err => this.handleErrorDetail(err))
            )
            
        }
    }

        /**
     *  Get the protection products monthly payment
     */
    public getPPMonthlyPayment(data): Observable<any> {

        // https://mobile-api.rti.dev.toyota.com/payment-gateway/dealers/24022/payments
        this._path = `${this.environment.MST_BASE_SERVICE_URL}payment-nexgen/dealers/${this.dealerCode}/payments`;        
        if(!isNil(data.payload.vehicle) && !isNil(data.payload.vehicle.invoiceAmount)){
            delete data.payload.vehicle.invoiceAmount;
        }
        return this.httpClient.post(this._path, this.stampScreen(data.payload, DebugScreen.WriteupDetail, DebugAction.CalculatePpPayment)).pipe(
            // map((response: Response) => {
            map(response => response), catchError(err => this.handleErrorDetail(err))
        )
    }

    /**
     * Get the Dfi Status value
     */
    public getDfiStatus(dealJAckId): Observable<any> {

        this._path = `${this.environment.MST_BASE_SERVICE_URL  }digitalfi/dealers/${this.dealerCode}/dealstatus/${dealJAckId}${  this.brand}`;
        // console.log(" Url path == >  ", this._path);

        return this.httpClient.get(this._path).pipe(
            map(response => {
                return response['status'] === 200 ? response : this.handleErrorDetail(response)
            }),
            catchError(err => this.handleErrorDetail(err))
        )
    }

    /**
     * Get the Inventory Vehicle details
     */
    public getInventoryVehicle(dealRoute: models.DealRoute): Observable<any> {
        if(!isNil(dealRoute) && !isNil(dealRoute.vehicleType)) {
            if ((dealRoute.vehicleType.toLowerCase() === ViewConstants.VEHICLE_TYPE_NEW.toLowerCase())) { // If the vehicle is New  
                this._path = `${this.environment.BASE_SERVICE_URL  }/dealer-inventory/vehicles/${dealRoute.vin}?isMaxDealerCash=true&dealerCd=${this.dealerCode}&includeInvPooling=true`;
            } else if (!this.sharedService.isUVIEndpoint) { // UVI is false
                this._path = `${this.environment.BASE_SERVICE_URL  }/dealer-inventory/usedvehicles/${dealRoute.vin}?dealerCd=${this.dealerCode}`;
            } else { // USED and UVI is TRUE
                this._path = `${this.environment.USED_VEHICLE_BASE_SERVICE_URL  }/used-vehicle-inventory/vehicles/${dealRoute.vin}?dealerCd=${this.dealerCode}`;
            }
        }
        // this._path = environment.BASE_SERVICE_URL + `/dealer-inventory/vehicles/${dealRoute.vin}`;

        return this.httpClient.get(this._path).pipe(
            map(response => response),
            catchError(err => this.handleErrorDetail(err))
        )
    }
    
    public getVspecurl(data):Observable<any>{ 
        this._path = this.environment.MST_BASE_SERVICE_URL + `user/${this.dealerCode}/share/${data.shareConfigDetails.vin}?type=${data.shareConfigDetails.type}&shortUrl=${data.shareConfigDetails.shortUrlStatus}`;       
        if (this.sharedService?.setDealer && !isNil(this.sharedService?.setOCA)) {
             this._path += `&setOca=${this.sharedService?.setOCA}`;
        }
        return this.httpClient.post(this._path,data.dealDetails).pipe(
        map(response => response),
        catchError(err => this.handleErrorDetail(err))
        )
      
    }
    public getEmailClient(data):Observable<any>{
        this._path = `${this.environment.MST_BASE_SERVICE_URL  }dealers/email-notification`;       
        return this.httpClient.post(this._path,data).pipe(
        map(response => response),
        catchError(err => this.handleErrorDetail(err))
        )
      
    }
    public lastTwoYearsVehiclesFilterTransform(seriesData: any, args: any[]) {
        //This variable is used to store dictionary of series data 
        const seriesDictionary: { [series: string]: {}[] } = {};
        //looping over series data list to generate dictionary of series data
        seriesData.forEach(item => {
            item.series_list.forEach(series => {
                if (seriesDictionary[series.title] === undefined || seriesDictionary[series.title] === null) {
                    seriesDictionary[series.title] = [];
                }

                series['year'] = item.year;
                seriesDictionary[series.title].push(series);
            });
        });
        return seriesDictionary;
    }
    latestModelVehicleTransform(value: any, args: any[]) {
        const uniqueVehicles: any[] = [];
        if (value !== undefined) {
            for (const key in value) {
                let maxYear = value[key][0]['year'];
                let maxIndex = 0;
                //Iterate over seriesDictionary object based on series to get final unique vehicles list
                value[key].forEach((element, index) => {
                    if (maxYear < element.year) {
                        maxYear = element.year;
                        maxIndex = index;
                    }
                });
                uniqueVehicles.push(value[key][maxIndex]);
            }
        }
        return uniqueVehicles;
    }
    public getSeriesConfigurationData(brand) {
        return this.seriesConfigurationdata[brand.toUpperCase()].new
    }

    public getTCUVSeriesConfigurationData(brand) {
        return this.tcuvSeriesConfigurationdata[brand.toUpperCase()].tcuv;
    }
    public setSeriesConfigurationData(seriesConfigurationdata) {
        return this.seriesConfigurationdata = seriesConfigurationdata;
    }

    public setTCUVSeriesConfigurationData(seriesConfigurationdata) {
        this.tcuvSeriesConfigurationdata = seriesConfigurationdata;
    //    return this.getSeries();
    }
    setSeriesData() {
        const seriesDataFromService = this.getSeriesConfigurationData(this.sharedService.relationshipTypeCode).seriesMapping;
        if (seriesDataFromService !== undefined) {
            this.seriesData = {};
            seriesDataFromService.forEach(vehicle => {
                let vehicleCategory: any = vehicle.category;
                vehicleCategory = vehicleCategory.split(',');
                vehicleCategory.forEach(category => {
                    if (this.seriesData[category] === undefined) {
                        this.seriesData[category] = [];
                    }
                    this.seriesData[category].push(vehicle.code);
                });
            });
        }
    }
    getSeriesData() {
        this.setSeriesData();
        return this.seriesData;
    }
    public setTCUVSeriesData() {
        const seriesDataFromService = this.getTCUVSeriesConfigurationData(this.sharedService.relationshipTypeCode).seriesMapping;
        // let categories = this.getTCUVSeriesData().categories;
        if (seriesDataFromService !== undefined) {
            this.tcuvSeriesData = {};
            seriesDataFromService.forEach(vehicle => {
                let vehicleCategory: any = vehicle.category;
                vehicleCategory = vehicleCategory.split(',');
                vehicleCategory.forEach(category => {
                    if (this.tcuvSeriesData[category] === undefined) {
                        this.tcuvSeriesData[category] = [];
                    }
                    this.tcuvSeriesData[category].push(vehicle.code);
                });
            });
        }
    }

    public getTCUVSeriesData() {
        this.setTCUVSeriesData();
        return this.tcuvSeriesData;
    }
    // vehicleCategoryTransform(value: any[], args: any) {
    //     //Dictionary to store the <key,value> pairs of vehicle category and corresponding vehicles
    //     var vehicleCategories: { [category: string]: any[]; } = {};
    //     let seriesMapping = (args?.toLowerCase() === "new") ? this.getSeriesConfigurationData(this.sharedService.relationshipTypeCode).seriesMapping : this.getTCUVSeriesConfigurationData(this.sharedService.relationshipTypeCode).seriesMapping;

    //     //Check if vehicle object contains values
    //     if (value != undefined) {
    //         //Loop through the vehicle objects returned by series web service
    //         for (let i = 0; i < value.length; i++) {
    //             let isFound = false;
    //             if (args?.toLowerCase() === "new") {
    //                 for (let key in this.getSeriesData()) {
    //                     if (this.getSeriesData()[key].indexOf(value[i].code) != -1) {
    //                         isFound = true;
    //                         if (vehicleCategories[key] == undefined || vehicleCategories[key] == null)
    //                             vehicleCategories[key] = [];

    //                         let s = seriesMapping.find(c => c.code === value[i].code);
    //                         if (Lodash.isNil(s.active) || s.active) { // do not add if active == false
    //                             if (!(this.autorizationService.brand.toLocaleLowerCase() === 'lexus')) {
    //                                 value[i]["mpge"] = (s?.mpge) ? s?.mpge : "MPG";
    //                             }
    //                             vehicleCategories[key].push(value[i]);
    //                         }
    //                         //break;
    //                     }
    //                 }
    //             }
    //             else {
    //                 for (let key in this.getTCUVSeriesData()) {
    //                     if (this.getTCUVSeriesData()[key].indexOf(value[i].code) != -1) {
    //                         isFound = true;
    //                         if (vehicleCategories[key] == undefined || vehicleCategories[key] == null)
    //                             vehicleCategories[key] = [];

    //                         let s = seriesMapping.find(c => c.code === value[i].code);
    //                         if (Lodash.isNil(s.active) || s.active) { // do not add if active == false
    //                             vehicleCategories[key].push(value[i]);
    //                         }

    //                         //break;
    //                     }
    //                 }
    //             }

    //             if (!isFound) {
    //                 if (this.autorizationService.brand.toLocaleLowerCase() === 'lexus') {
    //                     if (vehicleCategories['SEDANS'] == undefined || vehicleCategories['SEDANS'] == null)
    //                         vehicleCategories['SEDANS'] = [];

    //                     vehicleCategories['SEDANS'].push(value[i]);
    //                 } else {
    //                     if (vehicleCategories['Cars & Minivan'] == undefined || vehicleCategories['Cars & Minivan'] == null)
    //                         vehicleCategories['Cars & Minivan'] = [];

    //                     value[i]["mpge"] = "MPG";
    //                     vehicleCategories['Cars & Minivan'].push(value[i]);
    //                 }
    //             }
    //         }
    //     }
    //     //return the dictionary containing categories and their corresponding vehicles
    //     return vehicleCategories;
    // }
    seriesSorting(array): any {
         array.sort(this.sort_by('startingMsrp'));
        return array;
    }  
    default_cmp = function (a, b) {
        if (a === b) {return 0;}
        return a < b ? -1 : 1;
    }
    getCmpFunc = function (primer, reverse) {
        let dfc = this.default_cmp,
            cmp = this.default_cmp;
        if (primer) {
            cmp = function (a, b) {
                return dfc(primer(a), primer(b));
            };
        }
        if (reverse) {
            return function (a, b) {
                return -1 * cmp(a, b);
            };
        }
        return cmp;
    };

    // actual implementation
    sort_by(val) {
        let fields = [],
            n_fields = arguments.length,
            field, name, cmp;

        // preprocess sorting options
        for (let i = 0; i < n_fields; i++) {
            field = arguments[i];
            if (typeof field === 'string') {
                name = field;
                cmp = this.default_cmp;
            }
            else {
                name = field.name;
                cmp = this.getCmpFunc(field.primer, field.reverse);
            }
            fields.push({
                name: name,
                cmp: cmp
            });
        }

        // final comparison function
        return function (A, B) {
            let name, result;
            for (let i = 0; i < n_fields; i++) {
                result = 0;
                field = fields[i];
                name = field.name;

                result = field.cmp(A[name], B[name]);
                if (result !== 0) {break;}
            }
            return result;
        }
    }
    private transformSeriesData() {
        this.seriesList = []; this.seriesData = {};
        // let lastTwoYearsVehicles = this.lastTwoYearsVehiclesFilterTransform(seriesData, []);

        // apply filter on the above filter data to get the latest model among two vehicles which belongs to same series
        // var uniqueVehicles = this.latestModelVehicleTransform(lastTwoYearsVehicles, []);

        // categorize vehicles based on categories
      
        // var vehiclecategories = this.vehicleCategoryTransform(uniqueVehicles, this.inventoryFilter);
        const vehiclecategories = this.seriesCategoryList();
        for (const key in vehiclecategories) {
            this.seriesData[key] = this.seriesSorting(vehiclecategories[key]);
        }

        for (const key in this.seriesData) {
            // for (let count = 0; count < this.seriesData[key].length; count++) {
            //     var item = this.seriesData[key][count];
            //     if (!this.seriesList.find(i => i.series_code === item.code)) {
            //         this.seriesList.push({ 'series_code': item.code, 'series_name': item.title, 'display_year': item.year, 'checked': true });
            this.seriesData[key]?.forEach(x => {
                if (!this.seriesList.find(i => i.series_code === x.seriesCode)) {
                  this.seriesList.push({ 'series_code': x.seriesCode, 'series_name': x.marketingSeries, 'display_year': x?.year, 'checked': true });
                }
            })
        }
        this.newSeriesData = this.seriesList;
        return this.newSeriesData;
        // return this.storeModelCodes(lastTwoYearsVehicles);
        // return this.bothResponseData;
    }
    storeModelCodes(series) {
        const series_models: { [series: string]: string[] } = {};

        for (const key in series) {
            const models = [];
            series[key].forEach(item => {
                item.trims.forEach(trim => {
                    if (trim.code !== '') {
                        models.push(trim.code);
                    }
                });
            });
            const uniqueModels = this.unique(models);
            let seriesModel = series_models[key];
            if (seriesModel === undefined || seriesModel == null) {
                seriesModel = [];
                seriesModel = uniqueModels;
                series_models[key] = seriesModel;
            } else {
                series_models[key] = uniqueModels;
            }
        }
        this.seriesModelCodes = series_models;
        const seriesArray = [];
        this.seriesList.forEach(ser => {
            if (ser.series_name.toLowerCase() === this.selectedSeriesList.toLowerCase()) {
                seriesArray.push(ser);
            }
        })
        return this.seriesArray = seriesArray;
        // this.getInventoryDataS(this.sharedService.dealerCode, this.inventoryFilter, seriesArray, 1, this.initialService);
        // this.bothResponseData = {seriesResponseData:this.seriesResponseData,inventoryResponseData: this.inventoryResponseData}
        // return this.bothResponseData;

    }
    private unique(arr: string[]): string[] {
        const result: string[] = [];
        arr.forEach(item => {
            if (result.indexOf(item) === -1) {
                result.push(item);
            }
        });
        return result;
    }
    getSeriesModelCodes(series: string) {
        if (this.seriesModelCodes[series] !== undefined)
            {return this.seriesModelCodes[series];}
        else
            {return [];}
    }
    public getSeriesDataService(): Observable<any> {
        let seriesData;
        const path1 = `${this.environment.MST_BASE_SERVICE_URL  }dealers/${  this.sharedService.dealerCode  }/series-configuration?v=2.0`;

        return this.httpClient.get(path1).pipe(switchMap(configurationResponse => {
            this.sharedService.seriesConfiguration=configurationResponse;
            this.seriesConfigurationdata = this.tcuvSeriesConfigurationdata = configurationResponse;
            this.seriesConfiguration = configurationResponse[this.sharedService.relationshipTypeCode.toUpperCase()];
            // this.seriesConfiguration?.configuration?.forEach(series => {
            //     let newModels = [];
            //     series?.modelCodes?.map(x => x?.models)?.forEach(e => {
            //       newModels = newModels.concat(e);
            //     });
            //     series.modelCodes = [...new Set(newModels)]?.sort();
  
            //     let certModels = [];
            //     series?.tcuvModels?.map(x => x?.models)?.forEach(e => {
            //       certModels = certModels.concat(e);
            //     });
            //     series.tcuvModels = [...new Set(certModels)]?.sort();
            //   });
            this.seriesConfiguration?.vehicleTypes?.forEach((x,index) => {x.order = index + 1 });
            this.setSeriesConfigurationData(configurationResponse);
            // seriesData = this.setTCUVSeriesConfigurationData(configurationResponse);
            // const path = this.environment.MST_BASE_SERVICE_URL + 'dealers/' + this.sharedService.dealerCode + '/efc/series?brand=' + this.sharedService.relationshipTypeCode;
            // return this.httpClient.get(path).pipe(switchMap(resp => {
            //     this.seriesResponseData = resp;
             this.transformSeriesData();
            // }))
            return this.seriesConfiguration
        }))
    }
    public getAddress(input):  Promise<any>{
        let url;
        return new Promise((resolve, reject) => {
            if( typeof input === 'string') // zipcode alone
            {url = this.httpClient.get(`${this.environment.MST_BASE_SERVICE_URL  }dealers/${  this.sharedService.dealerCode  }/express-address?maxRecords=1&address=&city=&state=&` + `zipCode` + `=${  input}`)}
            else    //other fields
            {
                url = this.httpClient.get(`${this.environment.MST_BASE_SERVICE_URL  }dealers/${  this.sharedService.dealerCode  }/express-address?maxRecords=10&address=${ input.address }&city=${ input.city}&state=${input.state }&zipCode` + `=${  input.zipcode}`)

            }
            url.pipe(                
                map((res: any) => {
                  return res;
                }),
                catchError((res: any) => {
                  if (res.hasOwnProperty('message') && (res.message.toString().toLowerCase().indexOf('timeout') > -1)) {
                    return of('timeout');
                  } else {
                    return of(res);
                  }
                })
              ).subscribe(data => {
                if(typeof input === 'string'){
                  resolve(data);
                }
                else{
                    resolve(data.Results);
                }
              }, error => {
                reject('Auto complete failed');
              })
          });
        
    }
    searchCustomer(bodyData): Promise<any> {
        return new Promise((resolve, reject) => {

            this.httpClient.post(`${this.environment.MST_BASE_SERVICE_URL  }retail-deals/dealers/${  this.sharedService.dealerCode  }/offers/search`, this.stampScreen(bodyData, DebugScreen.WriteupDetail, DebugAction.SearchCustomer))
                .pipe(
                    map((res: any) => {
                        return { json: res };
                    }),
                    catchError((res: any) => {
                        if (res.hasOwnProperty('message') && (res.message.toString().toLowerCase().indexOf('timeout') > -1)) {
                            return of('timeout');
                        } else {
                            return of(res);
                        }
                    })
                ).subscribe(data => {
                    this.searchCustomerResponse = data;
                    if (this.searchCustomerResponse === 'timeout') {
                        reject('timeout');
                    } else if (this.searchCustomerResponse == null || this.searchCustomerResponse === undefined) {
                        reject('searchCustomerServiceError');
                    } else {
                        if (this.searchCustomerResponse.json?.length) {
                            this.searchCustomerResponse.json.forEach(customerObj => {
                                if (customerObj.leads?.length) {
                                    customerObj.leads = customerObj.leads.filter(leadObj => leadObj.leadType.toLowerCase() !== 'deal');
                                }
                            });
                            if (this.searchCustomerResponse.json?.length) {
                                this.searchCustomerResponse.json.forEach(customerObj => {
                                    if (customerObj.writeups?.length) {
                                        customerObj.writeups = customerObj.writeups.filter(writeupObj => (writeupObj.onlineStatus) && writeupObj.onlineStatus?.toLowerCase() !== 'cancelled' && writeupObj.showToCustomer !== false);
                                    }
                                });
                            }
                            resolve(this.searchCustomerResponse);
                        } else {
                            if(this.searchCustomerResponse.json.length === 0)
                            {resolve(this.searchCustomerResponse);}
                            else
                                {reject('searchCustomerServiceError');}
                            
                        }
                    }
                }, error => {
                    reject('searchCustomerServiceError');
                });
        });

    }
    retrieveCustomerDetails(customerLeadId): Promise<any> {
        return new Promise((resolve, reject) => {   
             this.httpClient.get(`${this.environment.MST_BASE_SERVICE_URL  }customers/${  customerLeadId}`)
            .pipe(              
              map((res: any) => {
                return { json: res   };
              }),
              catchError((res: any) => {
                if (res.hasOwnProperty('message') && (res.message.toString().toLowerCase().indexOf('timeoutErrorCode') > -1)) {
                  return of('timeoutErrorCode');
                } else {
                   return of(res);
                }
              })
            ).subscribe(data => {
                this.retrieveCustomerDetailsResponseData = data;
                 if (this.retrieveCustomerDetailsResponseData == null || this.retrieveCustomerDetailsResponseData === undefined) {
                  reject('retrieveCustomerDetailsServiceError');
                } else {
                  if (this.retrieveCustomerDetailsResponseData.hasOwnProperty('json') && this.retrieveCustomerDetailsResponseData.json) {
                    resolve(this.retrieveCustomerDetailsResponseData);
                  } else {                    
                      reject('retrieveCustomerDetailsServiceError');                    
                  }
                }
              }, error => {
                reject('retrieveCustomerDetailsServiceError');
              });
          
          
        });
      }
      public addCoBuyer(data): Observable<any> {
        if (!isNil(data)) {
            this.sharedService.dealTransactionId.subscribe(id => this.dealTransactionId = id);
            const path = `${this.environment.MST_BASE_SERVICE_URL  }deals/dealers/${  this.sharedService.dealerCode  }/cobuyer/${  this.dealTransactionId}` ;
                                                                                                                    
          

            return this.httpClient.request('put',path, { body: data }).pipe(
                // map((response: Response) => {
                map(response => response)
                , catchError(err => this.handleErrorDetail(err))
            )
            
        }
      }
      public removeCoBuyer(data): Observable<any> {
            this.sharedService.dealTransactionId.subscribe(id => this.dealTransactionId = id);
            const path = `${this.environment.MST_BASE_SERVICE_URL  }deals/dealers/${  this.sharedService.dealerCode  }/cobuyer/${  this.dealTransactionId}` ;
                                                                                    
          

             return this.httpClient.request('delete',path).pipe(
                // map((response: Response) => {
                map((response: any) =>{ 
                    const res ={};
                    res['data']   = response;          
                    res['removeBuyer']   = data;          
                    return res;
                } )
                , catchError(err => this.handleErrorDetail(err))
            )
            
        
      }
      public copyCobuyerTrades(data): Observable<any> {
        this.sharedService.dealTransactionId.subscribe(id => this.dealTransactionId = id);
        const path = `${this.environment.MST_BASE_SERVICE_URL  }deals/dealers/${  this.sharedService.dealerCode  }/cobuyer/${  this.dealTransactionId  }/trade` ;
                                                                                                                
        return this.httpClient.request('put',path, { body: data }).pipe(
            // map((response: Response) => {
            map(response => response)
            , catchError(err => this.handleErrorDetail(err))
        )
        
    
  }
    public getInventoryData(data): Observable<any> {
        const requestArray: Array<any> = [];
        const requestInstance: any = {};
        this.inventoryFilter = data.type;
        // if (data.type === 'new') {
        //     this.selectedSeriesList = data.model.seriesCode;
        // }
        // else if (data.type === 'certified') {
            this.selectedSeriesList = data.model;
        // }
        this.initialService = data.initialService;
        let seriesArray = [];
        // this.seriesList.forEach(ser => {
        //     if (ser.series_name.toLowerCase() === this.selectedSeriesList.toLowerCase()) {
        //         seriesArray.push(ser);
        //     }
        // })
        seriesArray = this.seriesList?.filter((el) => {
            return this.selectedSeriesList.some((f) => {
              return f.toLowerCase()=== el.series_name?.toLowerCase() ;
            });
        });
        
          if(seriesArray?.length ===0){
            seriesArray = this.seriesList?.filter((el) => {
                return this.selectedSeriesList?.some((f) => {
                  return f.toLowerCase().includes(el.series_name?.toLowerCase()) ;
                });
              });
          }

          // Ensure any selected series that is not part of the NEW series list
          // (e.g. a TCUV-only previous series) is still resolved to its series
          // code from the full series configuration.
          seriesArray = this.resolveSelectedSeries(seriesArray);
   
                return from(this.getInventoryDataS(this.sharedService.dealerCode, this.inventoryFilter, seriesArray, 1, this.initialService)).pipe(switchMap(inventoryResponse => {
                    return of(this.bothResponseData)
                }));
       

        // requestArray.push(requestInstance)
        // return forkJoin(requestArray);
    }
    public getInventoryDataS(dealerPartyId, inventoryFilter, selectedSeriesList = [], pageNo = 1, initialService = true): Promise<any> {
        return new Promise((resolve, reject) => {

            if (selectedSeriesList.length === 0 && (inventoryFilter !== "used" && inventoryFilter !== "certified")) {
                this.bothResponseData = {seriesResponseData:this.newSeriesData,inventoryResponseData: []}
                resolve([]);
            } else {
                let url: string;


                // NEW
                if (inventoryFilter === '' || inventoryFilter === "new") {

                    if (selectedSeriesList.length === 1 && selectedSeriesList[0] === 'all') {
                        if (this.sharedService.isOwningDealerLocation) {
                            url = `${this.environment.BASE_SERVICE_URL}/dealer-inventory/vehicles?includeInvPooling=true&dealer=${dealerPartyId}&pageSize=${100}&pageNo=${pageNo}`;

                        }
                        else {
                            url = `${this.environment.BASE_SERVICE_URL}/dealer-inventory/vehicles?dealer=${dealerPartyId}&pageSize=${100}&pageNo=${pageNo}`;
                        }
                    } else {
                        // Send only series codes as a consolidated unique list
                        // via the seriesCodes[] query param. A current series
                        // (one that has its own new model codes) additionally
                        // pulls in its configured previousSeriesCodes. A previous /
                        // TCUV-only series selected on its own is sent as-is, so
                        // deselecting the current series correctly narrows the
                        // request to just the previous series.
                        const expandedCodes = [];
                        selectedSeriesList
                            .map(series => series.series_code)
                            .filter(code => !isNil(code))
                            .forEach(code => {
                                expandedCodes.push(code);
                                if (this.getNewModelCodesForSeries(code).length > 0) {
                                    this.getPreviousSeriesCodes(code)
                                        .forEach(previousCode => expandedCodes.push(previousCode));
                                }
                            });
                        const seriesCodes = [...new Set(expandedCodes)];
                        if (seriesCodes.length === 0) {
                            resolve([]);
                        }
                          if (this.sharedService.isOwningDealerLocation) {
                        url = `${this.environment.BASE_SERVICE_URL  }/dealer-inventory/vehicles?includeInvPooling=true&dealer=${  dealerPartyId  }&seriesCodes[]=${  seriesCodes.join()  }&pageSize=${  100  }&pageNo=${  pageNo}`;
                          }
                          else{
                        url = `${this.environment.BASE_SERVICE_URL  }/dealer-inventory/vehicles?dealer=${  dealerPartyId  }&seriesCodes[]=${  seriesCodes.join()  }&pageSize=${  100  }&pageNo=${  pageNo}`;
                            
                          }
                    }
                }

                // USED
                else if (inventoryFilter === "used" || inventoryFilter === "tcuv-used" ||inventoryFilter === "cert-used"  ) {
                    //need to check
                    // if (this.constant.use_inventoryEndpoint_UVI === false) {
                    //   url = this.environment.BASE_SERVICE_URL + '/dealer-inventory/usedvehicles?dealer=' + dealerPartyId + '&pageSize=' + 100 + '&pageNo=' + pageNo;
                    // } else {
                    //   url = `${this.environment.INVENTORY_BASE_SERVICE_URL}/used-vehicle-inventory/vehicles?dealer=${dealerPartyId}&pageSize=100&pageNo=${pageNo}`;
                    // }
                    url = `${this.environment.USED_VEHICLE_BASE_SERVICE_URL}/used-vehicle-inventory/vehicles?dealer=${dealerPartyId}&pageSize=100`+`&pageNo=${  pageNo}`;

                }

                // CERTIFIED
                else {
                    let tcuvModels = [];
                    let models=[];
                    // let tcuvSeriesMapping = this.getTCUVSeriesConfigurationData(this.sharedService.relationshipTypeCode).seriesMapping;
                    // const tcuvVehicles = this.seriesConfiguration?.configuration;
                    selectedSeriesList.forEach(series => {
                        models = models.concat(this.getNewModelCodesForSeries(series.series_code));
          tcuvModels = tcuvModels.concat(this.getCertifiedModelCodesForSeries(series.series_code));
                    });
                    url = `${this.environment.USED_VEHICLE_BASE_SERVICE_URL}/used-vehicle-inventory/vehicles?dealer=${dealerPartyId}&pageSize=100&pageNo=${ pageNo}`;

                    // if (this.constant.use_inventoryEndpoint_UVI === false) {
                    //need to check
                    //   url = this.environment.BASE_SERVICE_URL + '/dealer-inventory/usedvehicles?dealer=' + dealerPartyId + '&pageSize=' + 100 + '&pageNo=' + pageNo;
                    // } else {
                    //   url = `${this.environment.INVENTORY_BASE_SERVICE_URL}/used-vehicle-inventory/vehicles?dealer=${dealerPartyId}&pageSize=100&pageNo=${pageNo}`;
                    // }

                    // if (selectedSeriesList.length && (!(selectedSeriesList.find(s => s.series_code === 'show all') || (selectedSeriesList.length === 1 && selectedSeriesList[0] === 'all')))) {

                    //     let tcuvModels = [];
                    //     let tcuvSeriesMapping = this.getTCUVSeriesConfigurationData(this.sharedService.relationshipTypeCode).seriesMapping;
                    //     selectedSeriesList.forEach(series => {
                    //         let tcuvSeries = tcuvSeriesMapping.find(element => element.code === series.series_code);
                    //         tcuvModels = tcuvModels.concat((tcuvSeries !== undefined && tcuvSeries.models !== undefined) ? tcuvSeries.models : []);
                    //     });

                    //     if (tcuvModels.length === 0) {
                    //         resolve([]);
                    //     }

                    //     url += '&model[]=' + tcuvModels.join();
                    // }
                }

                this.httpClient.get(url)
                    .pipe(
                        map((res: any) => {
                            return { json: res };
                        }),
                        catchError((res: any) => {
                            if (res.hasOwnProperty('message') && (res.message.toString().toLowerCase().indexOf('timeout') > -1)) {
                                return of('timeout');
                            } else {
                                return of(res);
                            }
                        })
                    )
                    .subscribe(response => {
                        const responseData: any = {};
                        if(!isNil(response.json))
                        {responseData['data'] = response.json;}
                        if (responseData === 'timeout') {
                            reject('timeout');
                        } else if (response.hasOwnProperty('status') && (response['status'] === 404 || response['status'] === 401)) {
                            this.bothResponseData = {seriesResponseData:{},inventoryResponseData: []}
                                                    resolve(this.inventoryResponseData);
                        } else if (responseData['data'] === undefined || responseData['data'] === null) {
                            reject('inventoryServiceError');
                        } else {
                            // if (response.hasOwnProperty('status') {
                            if (responseData['data'] !== undefined && responseData['data'] != null) {
                                const inventoryResponse = responseData['data'];
                                let vehicles = [];
                                if (inventoryFilter === '' || inventoryFilter === "new") {
                                    if (inventoryResponse !== undefined && inventoryResponse.vehicleSummary !== undefined) {
                                        inventoryResponse.vehicleSummary = inventoryResponse.vehicleSummary
                                        .filter(item => {
                                            if (item.dealerCategory !== undefined && item.dealerCategory !== null)
                                                {return item?.dealerCategory.indexOf('H') === -1 || (item?.dealerCategory.indexOf('G') === -1 && item?.dealerSubCategory?.indexOf('S') === -1 );}
                                        });
                                        vehicles = inventoryResponse.vehicleSummary
                                            .filter(item => {
                                                if (item.dealerCategory !== undefined && item.dealerCategory !== null)
                                                    {return item.dealerCategory.indexOf('F') === 0 || item.dealerCategory.indexOf('G') === 0 || item.dealerCategory.indexOf('L') === 0 || item.dealerCategory.indexOf('A') === 0;}
                                            });
                                    }
                                } else {
                                    if (inventoryResponse['vehicleSummary'] !== undefined && inventoryResponse['vehicleSummary'] !== null) {
                                        let filteredTcuvVehicles = [];
                                        filteredTcuvVehicles = inventoryResponse.vehicleSummary
                                            .filter(item => {
                                                if (item.certificationStatus !== undefined && item.certificationStatus !== null) {
                                                    if (inventoryFilter === "used") {
                                                        if (item.certificationStatus?.toLowerCase() !== 'certified') {
                                                            return item;
                                                        }
                                                    }else if (inventoryFilter === "cert-used") {
                                                        return item;
                                                    }  else if (inventoryFilter === "tcuv-used") {
                                                        return item;
                                                    } else {
                                                        if (item.certificationStatus.toLowerCase() === 'certified') {
                                                            return item;
                                                        }
                                                    }
                                                }/*  else if (inventoryFilter === "used") {
                                  return item;  //if certification status not available consider that as used vehicle.
                                } */
                                            });
                                        vehicles = this.transformTCUVVehhiclestoNormalInventory(filteredTcuvVehicles);
                                    }
                                }
                                const totalpage = (inventoryResponse !== undefined && inventoryResponse.pagination !== undefined) ? inventoryResponse.pagination.totalPages : 1;
                                if (totalpage > 1 && initialService) {
                                    this.inventoryResponseData = vehicles;
                                    const requestUrlArray = [];
                                    for (let i = 1; i < totalpage; i++) {
                                        requestUrlArray.push(this.getInventoryDataS(dealerPartyId, inventoryFilter, selectedSeriesList, i + 1, false));
                                    }
                                    forkJoin(requestUrlArray).pipe(
                                        catchError((res: any) => {
                                            const response: any = [res];
                                            if (res.hasOwnProperty('message') && (res.message.toString().toLowerCase().indexOf('timeout') > -1)) {
                                                return of('timeout');
                                            } else {
                                                return of(response);
                                            }
                                        })
                                    )
                                        .subscribe(
                                            inventoryData => {
                                                if (inventoryData === 'inventoryServiceError') {
                                                    reject('inventoryServiceError');
                                                } else if (inventoryData === 'timeout') {
                                                    reject('timeout');
                                                } else if (inventoryData == null || inventoryData === undefined) {
                                                    reject('pricingServiceError');
                                                } else {
                                                    inventoryData.forEach(data => {
                                                        this.inventoryResponseData = this.inventoryResponseData.concat(data);
                                                    });
                                                    this.bothResponseData = {seriesResponseData:this.newSeriesData,inventoryResponseData: this.inventoryResponseData}
                                                    resolve(this.inventoryResponseData);
                                                }
                                            }, error => {
                                                reject('pricingServiceError');
                                            });
                                } else {
                                    // this.inventoryResponseData = vehicles; 
                                    this.bothResponseData = {seriesResponseData:this.newSeriesData,inventoryResponseData: vehicles}
                                                    // resolve(this.bothResponseData);
                                    resolve(vehicles);
                                }


                            } else {
                                reject('inventoryServiceError');
                            }
                        }
                    }, (error) => {
                        reject('inventoryServiceError');
                    });
            }

        });
    }
    transformTCUVVehhiclestoNormalInventory(inventory) {
        inventory = inventory.map(item => {
            const resultantObject = {};
            resultantObject['vin'] = item.vin;
            resultantObject['stockNum'] = item.stockNumber;
            resultantObject['brand'] = item.brand;
            resultantObject['marketingSeries'] = item.marketingSeries;
            resultantObject['year'] = Lodash.get(item, 'model.modelYear', '');
            resultantObject['dealerCd'] = item.dealerCd;
            resultantObject['incomplete'] = item.incomplete;
            resultantObject['certificationType'] = item.certificationType;

            if (item.drivetrain)
                {resultantObject['drivetrain'] = item.drivetrain;}

            let engineNbr: any = null;
            if (item.engine !== undefined && item.engine != null) {
                if (item.engine.engineNbr !== undefined && item.engine.engineNbr != null) {
                    engineNbr = item.engine.engineNbr;
                }
                else {
                    engineNbr = '';
                }
            }
            else {
                engineNbr = '';
            }
            const engine = {
                engineCd: '25l4cylhybrid',
                name: engineNbr
            }
            resultantObject['engine'] = engine;
            resultantObject['transmission'] = item.transmission;
            resultantObject['category'] = 'G';
            resultantObject['dealerCategory'] = 'G';
            resultantObject['model'] = {
                modelCd: item.model.modelNumber,
                marketingName: item.model.marketingName,
                phaseCd: '',
                modelName: item.model.modelName
            };
            resultantObject['options'] = (!Lodash.isNil(item.options)) ? item.options : [];
            resultantObject['extColor'] = {
                colorCd: item.extColor.colorCd,
                marketingName: item.extColor.marketingName,
                colorHexCd: this.getExteriorHexCode(item.extColor.colorCd, item.brand)
            };
            resultantObject['intColor'] = {
                colorCd: item.intColor.colorCd,
                colorSwatch: '',
                marketingName: item.intColor.marketingName,
                colorHexCd: this.getInteriorHexCode(item.intColor.colorCd, item.brand)
            };
            resultantObject['flags'] = item.flags;
            resultantObject['reserveFlag'] = false;
            resultantObject['isPreSold'] = item?.isPreSold ? true : false;
            resultantObject['price'] = item.price;
            resultantObject['standardOptions'] = item.optionComments ? item.optionComments.map(item => item.comment) : [];
            resultantObject['type'] = 'CERTIFIED';
            if (item.certificationStatus === undefined || item.certificationStatus === null || (item.certificationStatus !== undefined && item.certificationStatus.toLowerCase() !== 'certified')) {
                resultantObject['usedVehicle'] = true;
            }
            resultantObject['mileage'] = item.mileage;
            resultantObject['certificationStatus'] = item.certificationStatus;
            resultantObject['media'] = item.media;
            resultantObject['acquiredDate'] = item.acquiredDate;
            resultantObject['grade'] = '';
            if (item.grade) {
                resultantObject['grade'] = item.grade
            }
            resultantObject['promoted'] = '';
            if (item.promoted) {
                resultantObject['promoted'] = item.promoted
            }
            return resultantObject;
        });
        return inventory;
    }
    getInteriorHexCode(code, brand) {
        brand = (brand !== undefined && brand !== null) ? brand.toLowerCase() : '';
        if (brand !== 'lexus') { // For lexus certified don't take from offline colors
            // in if condition && COLORS.exterior[code])
            // return COLORS.exterior[code].color;   
        } else {
            return '';
        }
    }

    getExteriorHexCode(code, brand) {
        brand = (brand !== undefined && brand !== null) ? brand.toLowerCase() : '';
        if (brand !== 'lexus') { // For lexus certified don't take from offline colors
            // in if condition && COLORS.exterior[code])
            // return COLORS.exterior[code].color;
        } else {
            return '';
        }
    }
    public getSeries(){
        let requestInstance: any = {};
        const path = `${this.environment.MST_BASE_SERVICE_URL  }dealers/${  this.sharedService.dealerCode  }/efc/series?brand=${  this.sharedService.relationshipTypeCode}`;
        requestInstance = this.httpClient.get(path).pipe(map(response => response), catchError(err => this.handleErrorDetail(err))).subscribe(configurationResponse => {
            this.seriesResponseData = configurationResponse;
           return  this.transformSeriesData();
        })
        // return this.bothResponseData;
    }
    public sendSMS(data):Observable<any>{
        this._path = `${this.environment.MST_BASE_SERVICE_URL  }dealers/sms-notification`;       
        return this.httpClient.post(this._path,data).pipe(
        map(response => response),
        catchError(err => this.handleErrorDetail(err))
        )
      
    }

    /**
     *  Get the Roll Payment data
     */
    public getRollPaymentData(aprDetails: models.Apr[]): Observable<any> {
        // this._path = this.environment.MST_BASE_SERVICE_URL + `digitalfi/dealers/${this.dealerCode}/worksheet` + this.brand;

        // let queryParameters = new URLSearchParams();

        const requestArray: Array<models.AprResponse> = [];
        let requestInstance: any = {};

        if (aprDetails) {
            aprDetails.forEach(apr => {
                apr.offers.forEach(dt=>
                    {
                        if(!isNil(dt.lender) && !isNil(dt.lender.name) && ((dt.lender.name.indexOf('Standard-') > -1) ||(dt.lender.name.indexOf('Special-') > -1)))
                        {
                          dt.lender.name=dt.lender.name.split('-')[1];
                        }
                    })
                    if(!isNil(apr.dealerAddOns)&& apr.dealerAddOns.length===0){
                        delete apr.dealerAddOns;
                    }else{
                        apr.dealerAddOns = [...new Set(apr.dealerAddOns)]
                    }
                this._path = `${this.environment.MST_BASE_SERVICE_URL  }payment-nexgen/dealers/${this.dealerCode}/payment/rollpayment`;
                requestInstance = this.httpClient.post(this._path, this.stampScreen(apr, DebugScreen.WriteupDetail, DebugAction.RollPayment)).pipe(
                    // map((response: Response) => {
                    map((response: any) => {
                        let aprResponse: models.AprResponse = {};

                        const successObj: any = {};
                        successObj.error = false;
                        aprResponse = response;
                        successObj.aprDetails = aprResponse;
                        successObj.isCustomAPR = apr.isCustomAPR;
                        successObj.tradeCount = apr.tradeInVehicle.length;
                        if (response.status === 200) {
                            successObj.value = true;
                        } else {
                            successObj.value = false;
                        }
                        return successObj;
                    }),
                    catchError(err => this.handleErrorDetail(err))
                )
                requestArray.push(requestInstance);
            });
        }
        return forkJoin(
            requestArray
        );

    }

    /**
    * get data to contract approved
    */
         public contractApproved(requestValue): Observable<any> {
            if(!isNil(requestValue) && !isNil(requestValue.dealDetails) && !isNil(requestValue.dealDetails.priceGrid) && !isNil(requestValue.dealDetails.priceGrid.details))
            {
     requestValue.dealDetails.priceGrid.details.map(dt=>
              {
                if(!isNil(dt.lender) && !isNil(dt.lender.name) && ((dt.lender.name.indexOf('Standard-') > -1) ||(dt.lender.name.indexOf('Special-') > -1)))
                     {
                           dt.lender.name=dt.lender.name.split('-')[1];
                    }
              })
            }

            const getRequestValue = {
                dealerCode: requestValue.dealerCode,
                dealTransactionId: requestValue.dealTransactionId,
                dealDetails: requestValue.dealDetails
            };
            const requestInstance: any = {};
    
            // this.logger.log('Executing send New Offer method');
            if (!isNil(getRequestValue) && !isNil(getRequestValue.dealDetails)) {
    
                const path = `${this.environment.MST_BASE_SERVICE_URL  }deals/dealers/${  getRequestValue.dealerCode  }/offers/${  getRequestValue.dealTransactionId  }/customer-acceptance?status=contract`;
                                                                                                                        
              
    
                return this.httpClient.request('put',path, { body: this.stampScreen(getRequestValue.dealDetails, DebugScreen.WriteupDetail, DebugAction.ContractApproved) }).pipe(
                    // map((response: Response) => {
                    map(response => response)
                    , catchError(err => this.handleErrorDetail(err))
                )
                
            }
            //return requestInstance;
        }
    
       public loadVehicleDios(reqParams):Observable<any>
        {
           // let requestInstance: any = {};
            // let requestArray: Array<any> = [];
            const path = `${this.environment.BASE_SERVICE_URL  }/dealer-accessories/dealers/${  reqParams.dealerCode  }/dios?modelYear=${  reqParams.modelYear  }&modelCode=${  reqParams.modelCode  }&brand=${  reqParams.brand  }&toyotaStandard=${  reqParams.toyotaStandard  }&visibleOnly=${  true}&ignoreVisibilityInfo=${  true}`;
            //Below change done for MSTM-32285 story
            //let path = this.environment.BASE_SERVICE_URL + '/dealer-accessories/dealers/' + reqParams.dealerCode + '/dios?modelYear=' + reqParams.modelYear + '&modelCode=' + reqParams.modelCode + '&toyotaStandard=' + reqParams.toyotaStandard + '&visibleOnly=' + true;
        //    if (reqParams.brand && reqParams.brand.toLowerCase() != 'toyota' && reqParams.brand.toLowerCase() != 'lexus') {
        //        path = this.environment.BASE_SERVICE_URL + '/dealer-accessories/dealers/' + reqParams.dealerCode + '/dios?modelYear=' + reqParams.modelYear + '&modelCode=' + reqParams.modelCode + '&brand=' + reqParams.brand + '&toyotaStandard=' + reqParams.toyotaStandard + '&visibleOnly=' + true;
        //    }

           return this.httpClient.get(path).pipe(
               map(response => response),
               catchError(err => this.handleErrorDetail(err))
           )
            // requestArray.push(requestInstance);
            // return forkJoin(
            //     requestArray
            // );
              }
        public getCustomerWriteupsTrades(
            customerId: string): Observable<any> {

            if (!customerId) {
                throw new Error('Catastrophe!! Required parameter customerid was null or undefined.');
            }
            const path = `${this.environment.MST_BASE_SERVICE_URL  }retail-deals/customer/${  customerId}`;
            return this.httpClient.get<models.CustomerTrade[]>(path).pipe(
                map(response => response)
                , catchError(err => this.handleErrorDetail(err))
            )
        }
        public sendToTransaction(requestValue): Observable<any> {
            if(!isNil(requestValue) && !isNil(requestValue.dealDetails) && !isNil(requestValue.dealDetails.priceGrid) && !isNil(requestValue.dealDetails.priceGrid.details))
            {
     requestValue.dealDetails.priceGrid.details.map(dt=>
              {
                if(!isNil(dt.lender) && !isNil(dt.lender.name) && ((dt.lender.name.indexOf('Standard-') > -1) ||(dt.lender.name.indexOf('Special-') > -1)))
                {
                  dt.lender.name=dt.lender.name.split('-')[1];
                }
              })
            }
            const getRequestValue = {
                dealerCode: requestValue.dealerCode,
                dealTransactionId: requestValue.dealTransactionId,
                dealDetails: requestValue.dealDetails
            };
            if (!isNil(getRequestValue) && !isNil(getRequestValue.dealDetails)) {
    
                const path =  `${this.environment.MST_BASE_SERVICE_URL  }deals/sendDealToFinance/dealers/${getRequestValue.dealerCode}/${getRequestValue.dealTransactionId}`;
                return this.httpClient.post(path, this.stampScreen(getRequestValue.dealDetails, DebugScreen.WriteupDetail, DebugAction.SendToFinance)).pipe(
                    // map((response: Response) => {
                    map(response => response)
                    , catchError(err => this.handleErrorDetail(err))
                )
                   }
     }

     public getNewInventoryMultiCall(dealerPartyId, inventoryFilter, selectedSeriesList = [], pageNo = 1, initialService = true): Promise<any> {
        return new Promise((resolve, reject) => {

            if (selectedSeriesList.length === 0 && inventoryFilter !== "used") {
                resolve([]);
            } else {
                let url: string;
                // NEW
                if (inventoryFilter === '' || inventoryFilter === "new") {
                    if (selectedSeriesList.length === 1 && selectedSeriesList[0] === 'all') {
                        if(this.sharedService.isOwningDealerLocation){
                        url = `${this.environment.BASE_SERVICE_URL  }/dealer-inventory/vehicles?includeInvPooling=true&dealer=${  dealerPartyId  }&pageSize=${  100  }&pageNo=${  pageNo}`;
                        }
                        else{
                         url = `${this.environment.BASE_SERVICE_URL  }/dealer-inventory/vehicles?dealer=${  dealerPartyId  }&pageSize=${  100  }&pageNo=${  pageNo}`;   
                        }
                    } 
                }
                this.httpClient.get(url)
                    .pipe(
                        map((res: any) => {
                            return { json: res };
                        }),
                        catchError((res: any) => {
                            if (res.hasOwnProperty('message') && (res.message.toString().toLowerCase().indexOf('timeout') > -1)) {
                                return of('timeout');
                            } else {
                                return of(res);
                            }
                        })
                    )
                    .subscribe(response => {
                        const responseData: any = {};
                        responseData['data'] = response.json;
                        if (responseData === 'timeout') {
                            reject('timeout');
                        } else if (response.hasOwnProperty('status') && response['status'] === 404) {
                            resolve([]);
                        } else if (responseData['data'] === undefined || responseData['data'] === null) {
                            reject('inventoryServiceError');
                        } else {
                            // if (response.hasOwnProperty('status') {
                            if (responseData['data'] !== undefined && responseData['data'] != null) {
                                const inventoryResponse = responseData['data'];
                                let vehicles = [];
                                if (inventoryFilter === '' || inventoryFilter === "new") {
                                    if (inventoryResponse !== undefined && inventoryResponse.vehicleSummary !== undefined) {
                                        vehicles = inventoryResponse.vehicleSummary
                                            .filter(item => {
                                                if (item.dealerCategory !== undefined && item.dealerCategory !== null)
                                                    {return item.dealerCategory.indexOf('F') === 0 || item.dealerCategory.indexOf('G') === 0 || item.dealerCategory.indexOf('L') === 0 || item.dealerCategory.indexOf('A') === 0;}
                                            });
                                    }
                                }
                                const totalpage = (inventoryResponse !== undefined && inventoryResponse.pagination !== undefined) ? inventoryResponse.pagination.totalPages : 1;
                                if (totalpage > 1 && initialService) {
                                    this.new_inventoryResponseData = vehicles;
                                    const requestUrlArray = [];
                                    for (let i = 1; i < totalpage; i++) {
                                        requestUrlArray.push(this.getNewInventoryMultiCall(dealerPartyId, inventoryFilter, selectedSeriesList, i + 1, false));
                                    }
                                    forkJoin(requestUrlArray).pipe(
                                        catchError((res: any) => {
                                            const response: any = [res];
                                            if (res.hasOwnProperty('message') && (res.message.toString().toLowerCase().indexOf('timeout') > -1)) {
                                                return of('timeout');
                                            } else {
                                                return of(response);
                                            }
                                        })
                                    )
                                        .subscribe(
                                            inventoryData => {
                                                if (inventoryData === 'inventoryServiceError') {
                                                    reject('inventoryServiceError');
                                                } else if (inventoryData === 'timeout') {
                                                    reject('timeout');
                                                } else if (inventoryData == null || inventoryData === undefined) {
                                                    reject('pricingServiceError');
                                                } else {
                                                    inventoryData.forEach(data => {
                                                        this.new_inventoryResponseData = this.new_inventoryResponseData.concat(data);
                                                    });
                                                    resolve(this.new_inventoryResponseData);
                                                }
                                            }, error => {
                                                reject('pricingServiceError');
                                            });
                                } else {
                                    resolve(vehicles);
                                }
                            } else {
                                reject('inventoryServiceError');
                            }
                        }
                    }, (error) => {
                        reject('inventoryServiceError');
                    });
            }

        });
    }

    cleanUpPaymentCall(payload){
        if(!isNil(payload.isCustomAPR))
        {
            delete payload.isCustomAPR;
        }
        if(!isNil(payload.accessories))
        {
            delete payload.accessories;
        }
        if(!isNil(payload.protection))
        {
            delete payload.protection;
        }
        if(!isNil(payload.markupIndicator))
        {
            delete payload.markupIndicator;
        }
        // if(!isNil(payload.rebate))
        // {
        //     delete payload.rebate;
        // }
    }
    public getWriteupLogs(dealTransactionId): Observable<any> {
        this._path = `${this.environment.MST_BASE_SERVICE_URL  }logs/dealers/${this.dealerCode}/summary/${dealTransactionId}`;
        return this.httpClient.post(this._path, {isFullResponse : true}).pipe(
            map(response => response['logData']),
            catchError(err => this.handleErrorDetail(err))
        )
    }


    public getVINDecode(data):Observable<any>{
        const path = `${this.environment.MST_BASE_SERVICE_URL  }scan/${this.dealerCode}/scanvin`;
        return this.httpClient.post(path,data).pipe(
        map(response => response),
        catchError(err => this.handleErrorDetail(err))
        )
      
    }

    public getplateTransferUIStatus(data):Observable<any>{
        const path = `${this.environment.MST_BASE_SERVICE_URL  }payment-nexgen/dealers/${this.dealerCode}/online/tradein/providers`;
        return this.httpClient.post(path,this.stampScreen(data, DebugScreen.WriteupDetail, DebugAction.CheckPlateTransfer)).pipe(
        map(response => response),
        catchError(err => this.handleErrorDetail(err))
        )
      
    }

    seriesCategoryList() {
        const vehiclecategories = {};
        this.seriesConfiguration?.vehicleTypes?.forEach(x => {
          vehiclecategories[x.vehicleTypeName] = [];
          const code = x.vehicleTypeCode;
          this.seriesConfiguration?.configuration?.forEach(y => {
            if (y?.modelCodes?.length) {
              if (y?.family?.length && y?.family?.indexOf(code) > -1) {
                vehiclecategories[x.vehicleTypeName].push(y);
              }
            }
          })
        });
    
        return vehiclecategories;
      }
    
      getNewModelCodesForSeries(seriesCode) {
        const s = this.seriesConfiguration.configuration.find(x => x.seriesCode === seriesCode);
        if ( s?.modelCodes?.length) {
          return [...new Set(s.modelCodes)];
        }
        return [];
      }
    
      getCertifiedModelCodesForSeries(seriesCode) {
        const s = this.seriesConfiguration.configuration.find(x => x.seriesCode === seriesCode);
        if ( s?.tcuvModels?.length) {
          return [...new Set(s.tcuvModels)]
        }
        return [];
      }
    
      getAllModelCodesForSeries(seriesCode) {
        const s = this.seriesConfiguration.configuration.find(x => x.seriesCode === seriesCode);
        if ( s?.modelCodes?.length) {
          const models = s.modelCodes;
          if (s?.tcuvModels?.length) {
            models.concat(s.tcuvModels);
          }
          return [...new Set(models)];
        }
        return [];
      }

      /**
       * Returns the normalized list of previous series codes for the given series.
       * - drops self-references (a series listing its own code)
       * - de-duplicates
       * - matches case-insensitively against configured series and returns the
       *   canonical config casing
       * - skips codes that do not map to any configured series
       */
      getPreviousSeriesCodes(seriesCode) {
        const configuration = this.seriesConfiguration?.configuration;
        if (!configuration?.length || isNil(seriesCode)) {
          return [];
        }
        const current = configuration.find(x => x?.seriesCode?.toLowerCase() === seriesCode.toLowerCase());
        const previousSeriesCodes = current?.previousSeriesCodes;
        if (!previousSeriesCodes?.length) {
          return [];
        }
        const canonicalByLower = new Map<string, string>();
        configuration.forEach(x => {
          if (x?.seriesCode) {
            canonicalByLower.set(x.seriesCode.toLowerCase(), x.seriesCode);
          }
        });
        const currentLower = seriesCode.toLowerCase();
        const seen = new Set<string>();
        const result: string[] = [];
        previousSeriesCodes.forEach(code => {
          if (isNil(code)) {
            return;
          }
          const lower = code.toLowerCase();
          // drop self-reference, de-duplicate and skip unmapped codes
          if (lower === currentLower || seen.has(lower) || !canonicalByLower.has(lower)) {
            return;
          }
          seen.add(lower);
          result.push(canonicalByLower.get(lower));
        });
        return result;
      }

      /**
       * Returns the previous series for the given series shaped for the filter
       * list ({ series_code, series_name, display_year }), pulling the display
       * name/year from each previous series' own configuration entry.
       */
      getPreviousSeriesEntries(seriesCode) {
        const configuration = this.seriesConfiguration?.configuration;
        if (!configuration?.length) {
          return [];
        }
        return this.getPreviousSeriesCodes(seriesCode).map(code => {
          const entry = configuration.find(x => x?.seriesCode === code);
          return {
            series_code: code,
            series_name: entry?.marketingSeries,
            display_year: entry?.year
          };
        });
      }

      /**
       * Same as getPreviousSeriesEntries but resolves the series by its marketing
       * name (case-insensitive, HTML-stripped) using the full series configuration.
       * This keeps the filter chips in sync with the inventory request even when
       * the component's series list uses a different series_code than the config.
       */
      getPreviousSeriesEntriesByName(seriesName) {
        const configuration = this.seriesConfiguration?.configuration;
        if (!configuration?.length || isNil(seriesName)) {
          return [];
        }
        const lower = this.stripSeriesHtml(seriesName).toLowerCase();
        const match = configuration.find(c => this.stripSeriesHtml(c?.marketingSeries)?.toLowerCase() === lower);
        if (!match?.seriesCode) {
          return [];
        }
        return this.getPreviousSeriesEntries(match.seriesCode);
      }

      private stripSeriesHtml(value: string): string {
        return (value || '').replace(/<[^>]*>/g, '');
      }

      /**
       * Resolves any selected series name that is not present in the NEW series
       * list (e.g. a TCUV-only previous series) to its series code using the full
       * series configuration, so the selected-series list stays the single source
       * of truth for the inventory request.
       */
      private resolveSelectedSeries(seriesArray) {
        const resolved = Array.isArray(seriesArray) ? [...seriesArray] : [];
        const configuration = this.seriesConfiguration?.configuration || [];
        const selectedNames = new Set(
          (this.selectedSeriesList || [])
            .filter(name => !isNil(name))
            .map(name => this.stripSeriesHtml(name).toLowerCase())
        );
        const resolvedNames = new Set(resolved.map(s => this.stripSeriesHtml(s.series_name)?.toLowerCase()));
        this.selectedSeriesList?.forEach(name => {
          if (isNil(name)) {
            return;
          }
          const lower = this.stripSeriesHtml(name).toLowerCase();
          if (resolvedNames.has(lower)) {
            return;
          }
          const match = configuration.find(c => this.stripSeriesHtml(c?.marketingSeries)?.toLowerCase() === lower);
          if (match) {
            resolved.push({ series_code: match.seriesCode, series_name: match.marketingSeries, display_year: match.year });
            resolvedNames.add(lower);
          }
        });
        // Drop spurious entries (e.g. a loose "includes" match that pulled in a
        // current series when only its previous/TCUV series is selected). Keep only
        // series that map to an actually-selected name so deselecting a series truly
        // narrows the request. When nothing is explicitly selected, keep as-is.
        if (selectedNames.size === 0) {
          return resolved;
        }
        return resolved.filter(s => selectedNames.has(this.stripSeriesHtml(s.series_name)?.toLowerCase()));
      }
}